"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";
const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const namesData = [{
  letter: "A",
  name: "Aaliyah",
  meaning: "High, exalted",
  url: "https://shulisnameshub.com/aaliyah-meaning/"
}, {
  letter: "A",
  name: "Abigail",
  meaning: "Father's joy",
  url: "https://shulisnameshub.com/abigail-meaning/"
}, {
  letter: "A",
  name: "Ada",
  meaning: "Noble",
  url: "https://shulisnameshub.com/ada-meaning/"
}, {
  letter: "A",
  name: "Adaline",
  meaning: "Noble one",
  url: "https://shulisnameshub.com/adaline-meaning/"
}, {
  letter: "A",
  name: "Addison",
  meaning: "Son of Adam",
  url: "https://shulisnameshub.com/addison-meaning/"
}, {
  letter: "A",
  name: "Adelaide",
  meaning: "Noble natured",
  url: "https://shulisnameshub.com/adelaide-meaning/"
}, {
  letter: "A",
  name: "Adeline",
  meaning: "Noble",
  url: "https://shulisnameshub.com/adeline-meaning/"
}, {
  letter: "A",
  name: "Adley",
  meaning: "Judicious",
  url: "https://shulisnameshub.com/adley-meaning/"
}, {
  letter: "A",
  name: "Adva",
  meaning: "Small wave",
  url: "https://shulisnameshub.com/adva-meaning/"
}, {
  letter: "A",
  name: "Adi",
  meaning: "Jewel",
  url: "https://shulisnameshub.com/adi-meaning/"
}, {
  letter: "A",
  name: "Adriana",
  meaning: "From Hadria",
  url: "https://shulisnameshub.com/adriana-meaning/"
}, {
  letter: "A",
  name: "Aila",
  meaning: "From the strong place",
  url: "https://shulisnameshub.com/aila-meaning/"
}, {
  letter: "A",
  name: "Ainsley",
  meaning: "One's own meadow",
  url: "https://shulisnameshub.com/ainsley-meaning/"
}, {
  letter: "A",
  name: "Alana",
  meaning: "Precious",
  url: "https://shulisnameshub.com/alana-meaning/"
}, {
  letter: "A",
  name: "Alaya",
  meaning: "High, exalted",
  url: "https://shulisnameshub.com/alaya-meaning/"
}, {
  letter: "A",
  name: "Alexandra",
  meaning: "Defender of mankind",
  url: "https://shulisnameshub.com/alexandra-meaning/"
}, {
  letter: "A",
  name: "Alexia",
  meaning: "Defender",
  url: "https://shulisnameshub.com/alexia-meaning/"
}, {
  letter: "A",
  name: "Alice",
  meaning: "Noble",
  url: "https://shulisnameshub.com/alice-meaning/"
}, {
  letter: "A",
  name: "Alina",
  meaning: "Bright, beautiful",
  url: "https://shulisnameshub.com/alina-meaning/"
}, {
  letter: "A",
  name: "Alisha",
  meaning: "Protected by God",
  url: "https://shulisnameshub.com/alisha-meaning/"
}, {
  letter: "A",
  name: "Alison",
  meaning: "Noble",
  url: "https://shulisnameshub.com/alison-meaning/"
}, {
  letter: "A",
  name: "Alivia",
  meaning: "Olive tree",
  url: "https://shulisnameshub.com/alivia-meaning/"
}, {
  letter: "A",
  name: "Alma",
  meaning: "Nourishing",
  url: "https://shulisnameshub.com/alma-meaning/"
}, {
  letter: "A",
  name: "Alora",
  meaning: "The Lord is my light",
  url: "https://shulisnameshub.com/alora-meaning/"
}, {
  letter: "A",
  name: "Amara",
  meaning: "Eternal",
  url: "https://shulisnameshub.com/amara-meaning/"
}, {
  letter: "A",
  name: "Amaya",
  meaning: "Night rain",
  url: "https://shulisnameshub.com/amaya-meaning/"
}, {
  letter: "A",
  name: "Amelia",
  meaning: "Work",
  url: "https://shulisnameshub.com/amelia-meaning/"
}, {
  letter: "A",
  name: "Amira",
  meaning: "Princess",
  url: "https://shulisnameshub.com/amira-meaning/"
}, {
  letter: "A",
  name: "Amy",
  meaning: "Beloved",
  url: "https://shulisnameshub.com/amy-meaning/"
}, {
  letter: "A",
  name: "Ana",
  meaning: "Grace",
  url: "https://shulisnameshub.com/ana-meaning/"
}, {
  letter: "A",
  name: "Anastasia",
  meaning: "Resurrection",
  url: "https://shulisnameshub.com/anastasia-meaning/"
}, {
  letter: "A",
  name: "Andrea",
  meaning: "Strong and brave",
  url: "https://shulisnameshub.com/andrea-meaning/"
}, {
  letter: "A",
  name: "Angela",
  meaning: "Messenger of God",
  url: "https://shulisnameshub.com/angela-meaning/"
}, {
  letter: "A",
  name: "Angelina",
  meaning: "Little angel",
  url: "https://shulisnameshub.com/angelina-meaning/"
}, {
  letter: "A",
  name: "Anika",
  meaning: "Grace",
  url: "https://shulisnameshub.com/anika-meaning/"
}, {
  letter: "A",
  name: "Anna",
  meaning: "Grace",
  url: "https://shulisnameshub.com/anna-meaning/"
}, {
  letter: "A",
  name: "Annabelle",
  meaning: "Graceful beauty",
  url: "https://shulisnameshub.com/annabelle-meaning/"
}, {
  letter: "A",
  name: "Annalise",
  meaning: "Graced with God's bounty",
  url: "https://shulisnameshub.com/annalise-meaning/"
}, {
  letter: "A",
  name: "Anne",
  meaning: "Grace",
  url: "https://shulisnameshub.com/anne-meaning/"
}, {
  letter: "A",
  name: "Annie",
  meaning: "Grace",
  url: "https://shulisnameshub.com/annie-meaning/"
}, {
  letter: "A",
  name: "Anya",
  meaning: "Grace",
  url: "https://shulisnameshub.com/anya-meaning/"
}, {
  letter: "A",
  name: "April",
  meaning: "To open",
  url: "https://shulisnameshub.com/april-meaning/"
}, {
  letter: "A",
  name: "Arabella",
  meaning: "Yielding to prayer",
  url: "https://shulisnameshub.com/arabella-meaning/"
}, {
  letter: "A",
  name: "Arden",
  meaning: "Valley of the eagle",
  url: "https://shulisnameshub.com/arden-meaning/"
}, {
  letter: "A",
  name: "Aria",
  meaning: "Air, song",
  url: "https://shulisnameshub.com/aria-meaning/"
}, {
  letter: "A",
  name: "Ariana",
  meaning: "Most holy",
  url: "https://shulisnameshub.com/ariana-meaning/"
}, {
  letter: "A",
  name: "Ariel",
  meaning: "Lion of God",
  url: "https://shulisnameshub.com/ariel-meaning/"
}, {
  letter: "A",
  name: "Ariella",
  meaning: "Lioness of God",
  url: "https://shulisnameshub.com/ariella-meaning/"
}, {
  letter: "A",
  name: "Artemis",
  meaning: "Butcher",
  url: "https://shulisnameshub.com/artemis-meaning/"
}, {
  letter: "A",
  name: "Arya",
  meaning: "Noble",
  url: "https://shulisnameshub.com/arya-meaning/"
}, {
  letter: "A",
  name: "Asher",
  meaning: "Happy, blessed",
  url: "https://shulisnameshub.com/asher-meaning/"
}, {
  letter: "A",
  name: "Ashley",
  meaning: "Dweller near the ash tree meadow",
  url: "https://shulisnameshub.com/ashley-meaning/"
}, {
  letter: "A",
  name: "Aspen",
  meaning: "Quaking tree",
  url: "https://shulisnameshub.com/aspen-meaning/"
}, {
  letter: "A",
  name: "Astrid",
  meaning: "Divinely beautiful",
  url: "https://shulisnameshub.com/astrid-meaning/"
}, {
  letter: "A",
  name: "Atia",
  meaning: "Gift",
  url: "https://shulisnameshub.com/atia-meaning/"
}, {
  letter: "A",
  name: "Aubree",
  meaning: "Elf ruler",
  url: "https://shulisnameshub.com/aubree-meaning/"
}, {
  letter: "A",
  name: "Aubrey",
  meaning: "Elf ruler",
  url: "https://shulisnameshub.com/aubrey-meaning/"
}, {
  letter: "A",
  name: "Audrey",
  meaning: "Noble strength",
  url: "https://shulisnameshub.com/audrey-meaning/"
}, {
  letter: "A",
  name: "August",
  meaning: "Great, magnificent",
  url: "https://shulisnameshub.com/august-meaning/"
}, {
  letter: "A",
  name: "Aurelia",
  meaning: "The golden one",
  url: "https://shulisnameshub.com/aurelia-meaning/"
}, {
  letter: "A",
  name: "Aurora",
  meaning: "Dawn",
  url: "https://shulisnameshub.com/aurora-meaning/"
}, {
  letter: "A",
  name: "Autumn",
  meaning: "Season of harvest",
  url: "https://shulisnameshub.com/autumn-meaning/"
}, {
  letter: "A",
  name: "Ava",
  meaning: "Life",
  url: "https://shulisnameshub.com/ava-meaning/"
}, {
  letter: "A",
  name: "Avayah",
  meaning: "Iniquity",
  url: "https://shulisnameshub.com/avayah-meaning/"
}, {
  letter: "A",
  name: "Avery",
  meaning: "Elf counsel",
  url: "https://shulisnameshub.com/avery-meaning/"
}, {
  letter: "A",
  name: "Aviana",
  meaning: "Bird",
  url: "https://shulisnameshub.com/aviana-meaning/"
}, {
  letter: "A",
  name: "Ayla",
  meaning: "Oak tree",
  url: "https://shulisnameshub.com/ayla-meaning/"
}, {
  letter: "B",
  name: "Bailey",
  meaning: "Bailiff",
  url: "https://shulisnameshub.com/bailey-meaning/"
}, {
  letter: "B",
  name: "Barbara",
  meaning: "Foreign woman",
  url: "https://shulisnameshub.com/barbara-meaning/"
}, {
  letter: "B",
  name: "Baylee",
  meaning: "Berry clearing",
  url: "https://shulisnameshub.com/baylee-meaning/"
}, {
  letter: "B",
  name: "Beatrice",
  meaning: "Bringer of joy",
  url: "https://shulisnameshub.com/beatrice-meaning/"
}, {
  letter: "B",
  name: "Beatrix",
  meaning: "She who brings happiness",
  url: "https://shulisnameshub.com/beatrix-meaning/"
}, {
  letter: "B",
  name: "Belinda",
  meaning: "Beautiful",
  url: "https://shulisnameshub.com/belinda-meaning/"
}, {
  letter: "B",
  name: "Bella",
  meaning: "Beautiful",
  url: "https://shulisnameshub.com/bella-meaning/"
}, {
  letter: "B",
  name: "Belle",
  meaning: "Beautiful",
  url: "https://shulisnameshub.com/belle-meaning/"
}, {
  letter: "B",
  name: "Bernadette",
  meaning: "Brave as a bear",
  url: "https://shulisnameshub.com/bernadette-meaning/"
}, {
  letter: "B",
  name: "Bethany",
  meaning: "House of figs",
  url: "https://shulisnameshub.com/bethany-meaning/"
}, {
  letter: "B",
  name: "Beverly",
  meaning: "From the beaver meadow",
  url: "https://shulisnameshub.com/beverly-meaning/"
}, {
  letter: "B",
  name: "Bianca",
  meaning: "White",
  url: "https://shulisnameshub.com/bianca-meaning/"
}, {
  letter: "B",
  name: "Billie",
  meaning: "Resolute protection",
  url: "https://shulisnameshub.com/billie-meaning/"
}, {
  letter: "B",
  name: "Blair",
  meaning: "Field, plain",
  url: "https://shulisnameshub.com/blair-meaning/"
}, {
  letter: "B",
  name: "Blaire",
  meaning: "Dweller on the plain",
  url: "https://shulisnameshub.com/blaire-meaning/"
}, {
  letter: "B",
  name: "Blake",
  meaning: "Fair-haired",
  url: "https://shulisnameshub.com/blake-meaning/"
}, {
  letter: "B",
  name: "Blakely",
  meaning: "Dark meadow",
  url: "https://shulisnameshub.com/blakely-meaning/"
}, {
  letter: "B",
  name: "Bonnie",
  meaning: "Beautiful, cheerful",
  url: "https://shulisnameshub.com/bonnie-meaning/"
}, {
  letter: "B",
  name: "Braelynn",
  meaning: "Broad valley",
  url: "https://shulisnameshub.com/braelynn-meaning/"
}, {
  letter: "B",
  name: "Braya",
  meaning: "Noble",
  url: "https://shulisnameshub.com/braya-meaning/"
}, {
  letter: "B",
  name: "Breanna",
  meaning: "Strong",
  url: "https://shulisnameshub.com/breanna-meaning/"
}, {
  letter: "B",
  name: "Bria",
  meaning: "Noble",
  url: "https://shulisnameshub.com/bria-meaning/"
}, {
  letter: "B",
  name: "Briana",
  meaning: "Strong, virtuous",
  url: "https://shulisnameshub.com/briana-meaning/"
}, {
  letter: "B",
  name: "Brianna",
  meaning: "Strong, virtuous",
  url: "https://shulisnameshub.com/brianna-meaning/"
}, {
  letter: "B",
  name: "Briar",
  meaning: "Thorny bush",
  url: "https://shulisnameshub.com/briar-meaning/"
}, {
  letter: "B",
  name: "Bridget",
  meaning: "Exalted one",
  url: "https://shulisnameshub.com/bridget-meaning/"
}, {
  letter: "B",
  name: "Brielle",
  meaning: "God is my strength",
  url: "https://shulisnameshub.com/brielle-meaning/"
}, {
  letter: "B",
  name: "Brier",
  meaning: "Heather",
  url: "https://shulisnameshub.com/brier-meaning/"
}, {
  letter: "B",
  name: "Brinley",
  meaning: "Burnt meadow",
  url: "https://shulisnameshub.com/brinley-meaning/"
}, {
  letter: "B",
  name: "Bristol",
  meaning: "Meeting place by the bridge",
  url: "https://shulisnameshub.com/bristol-meaning/"
}, {
  letter: "B",
  name: "Britney",
  meaning: "From Britain",
  url: "https://shulisnameshub.com/britney-meaning/"
}, {
  letter: "B",
  name: "Brittany",
  meaning: "From Britain",
  url: "https://shulisnameshub.com/brittany-meaning/"
}, {
  letter: "B",
  name: "Brooke",
  meaning: "Small stream",
  url: "https://shulisnameshub.com/brooke-meaning/"
}, {
  letter: "B",
  name: "Brooklyn",
  meaning: "Broken land",
  url: "https://shulisnameshub.com/brooklyn-meaning/"
}, {
  letter: "B",
  name: "Brooklynn",
  meaning: "Water, small stream",
  url: "https://shulisnameshub.com/brooklynn-meaning/"
}, {
  letter: "B",
  name: "Brylee",
  meaning: "Noble",
  url: "https://shulisnameshub.com/brylee-meaning/"
}, {
  letter: "B",
  name: "Brynlee",
  meaning: "Burnt meadow",
  url: "https://shulisnameshub.com/brynlee-meaning/"
}, {
  letter: "B",
  name: "Brynn",
  meaning: "Hill",
  url: "https://shulisnameshub.com/brynn-meaning/"
}, {
  letter: "C",
  name: "Cadence",
  meaning: "Rhythm",
  url: "https://shulisnameshub.com/cadence-meaning/"
}, {
  letter: "C",
  name: "Cali",
  meaning: "Most beautiful",
  url: "https://shulisnameshub.com/cali-meaning/"
}, {
  letter: "C",
  name: "Callie",
  meaning: "Beautiful",
  url: "https://shulisnameshub.com/callie-meaning/"
}, {
  letter: "C",
  name: "Calliope",
  meaning: "Beautiful voice",
  url: "https://shulisnameshub.com/calliope-meaning/"
}, {
  letter: "C",
  name: "Camila",
  meaning: "Young ceremonial attendant",
  url: "https://shulisnameshub.com/camila-meaning/"
}, {
  letter: "C",
  name: "Camilla",
  meaning: "Free-born",
  url: "https://shulisnameshub.com/camilla-meaning/"
}, {
  letter: "C",
  name: "Camille",
  meaning: "Perfect",
  url: "https://shulisnameshub.com/camille-meaning/"
}, {
  letter: "C",
  name: "Camryn",
  meaning: "Crooked nose",
  url: "https://shulisnameshub.com/camryn-meaning/"
}, {
  letter: "C",
  name: "Capri",
  meaning: "Island",
  url: "https://shulisnameshub.com/capri-meaning/"
}, {
  letter: "C",
  name: "Cara",
  meaning: "Dear",
  url: "https://shulisnameshub.com/cara-meaning/"
}, {
  letter: "C",
  name: "Carina",
  meaning: "Dear little one",
  url: "https://shulisnameshub.com/carina-meaning/"
}, {
  letter: "C",
  name: "Carla",
  meaning: "Free man",
  url: "https://shulisnameshub.com/carla-meaning/"
}, {
  letter: "C",
  name: "Carly",
  meaning: "Free man",
  url: "https://shulisnameshub.com/carly-meaning/"
}, {
  letter: "C",
  name: "Carmen",
  meaning: "Song",
  url: "https://shulisnameshub.com/carmen-meaning/"
}, {
  letter: "C",
  name: "Carolina",
  meaning: "Free man",
  url: "https://shulisnameshub.com/carolina-meaning/"
}, {
  letter: "C",
  name: "Caroline",
  meaning: "Free man",
  url: "https://shulisnameshub.com/caroline-meaning/"
}, {
  letter: "C",
  name: "Carolyn",
  meaning: "Free man",
  url: "https://shulisnameshub.com/carolyn-meaning/"
}, {
  letter: "C",
  name: "Casey",
  meaning: "Brave in battle",
  url: "https://shulisnameshub.com/casey-meaning/"
}, {
  letter: "C",
  name: "Cassandra",
  meaning: "Shining upon man",
  url: "https://shulisnameshub.com/cassandra-meaning/"
}, {
  letter: "C",
  name: "Cassidy",
  meaning: "Curly-haired",
  url: "https://shulisnameshub.com/cassidy-meaning/"
}, {
  letter: "C",
  name: "Catalina",
  meaning: "Pure",
  url: "https://shulisnameshub.com/catalina-meaning/"
}, {
  letter: "C",
  name: "Catherine",
  meaning: "Pure",
  url: "https://shulisnameshub.com/catherine-meaning/"
}, {
  letter: "C",
  name: "Cecile",
  meaning: "Blind",
  url: "https://shulisnameshub.com/cecile-meaning/"
}, {
  letter: "C",
  name: "Cecilia",
  meaning: "Blind",
  url: "https://shulisnameshub.com/cecilia-meaning/"
}, {
  letter: "C",
  name: "Cecily",
  meaning: "Blind",
  url: "https://shulisnameshub.com/cecily-meaning/"
}, {
  letter: "C",
  name: "Celeste",
  meaning: "Heavenly",
  url: "https://shulisnameshub.com/celeste-meaning/"
}, {
  letter: "C",
  name: "Celia",
  meaning: "Heavenly",
  url: "https://shulisnameshub.com/celia-meaning/"
}, {
  letter: "C",
  name: "Celine",
  meaning: "Heavenly",
  url: "https://shulisnameshub.com/celine-meaning/"
}, {
  letter: "C",
  name: "Chana",
  meaning: "Grace",
  url: "https://shulisnameshub.com/chana-meaning/"
}, {
  letter: "C",
  name: "Chandler",
  meaning: "Candle maker",
  url: "https://shulisnameshub.com/chandler-meaning/"
}, {
  letter: "C",
  name: "Chanel",
  meaning: "Canal",
  url: "https://shulisnameshub.com/chanel-meaning/"
}, {
  letter: "C",
  name: "Charlee",
  meaning: "Free man",
  url: "https://shulisnameshub.com/charlee-meaning/"
}, {
  letter: "C",
  name: "Charleigh",
  meaning: "Free man",
  url: "https://shulisnameshub.com/charleigh-meaning/"
}, {
  letter: "C",
  name: "Charley",
  meaning: "Free man",
  url: "https://shulisnameshub.com/charley-meaning/"
}, {
  letter: "C",
  name: "Charlie",
  meaning: "Free man",
  url: "https://shulisnameshub.com/charlie-meaning/"
}, {
  letter: "C",
  name: "Charlotte",
  meaning: "Free man",
  url: "https://shulisnameshub.com/charlotte-meaning/"
}, {
  letter: "C",
  name: "Chaya",
  meaning: "Life",
  url: "https://shulisnameshub.com/chaya-meaning/"
}, {
  letter: "C",
  name: "Chelsea",
  meaning: "Chalk wharf",
  url: "https://shulisnameshub.com/chelsea-meaning/"
}, {
  letter: "C",
  name: "Cheyenne",
  meaning: "People of a different language",
  url: "https://shulisnameshub.com/cheyenne-meaning/"
}, {
  letter: "C",
  name: "Chloe",
  meaning: "Blooming",
  url: "https://shulisnameshub.com/chloe-meaning/"
}, {
  letter: "C",
  name: "Christina",
  meaning: "Follower of Christ",
  url: "https://shulisnameshub.com/christina-meaning/"
}, {
  letter: "C",
  name: "Christine",
  meaning: "Follower of Christ",
  url: "https://shulisnameshub.com/christine-meaning/"
}, {
  letter: "C",
  name: "Claire",
  meaning: "Clear, bright",
  url: "https://shulisnameshub.com/claire-meaning/"
}, {
  letter: "C",
  name: "Clara",
  meaning: "Clear, bright",
  url: "https://shulisnameshub.com/clara-meaning/"
}, {
  letter: "C",
  name: "Clare",
  meaning: "Bright",
  url: "https://shulisnameshub.com/clare-meaning/"
}, {
  letter: "C",
  name: "Clarissa",
  meaning: "Bright, clear",
  url: "https://shulisnameshub.com/clarissa-meaning/"
}, {
  letter: "C",
  name: "Claudia",
  meaning: "Lame",
  url: "https://shulisnameshub.com/claudia-meaning/"
}, {
  letter: "C",
  name: "Clementine",
  meaning: "Merciful",
  url: "https://shulisnameshub.com/clementine-meaning/"
}, {
  letter: "C",
  name: "Cleo",
  meaning: "Glory",
  url: "https://shulisnameshub.com/cleo-meaning/"
}, {
  letter: "C",
  name: "Clover",
  meaning: "Meadow flower",
  url: "https://shulisnameshub.com/clover-meaning/"
}, {
  letter: "C",
  name: "Colette",
  meaning: "Victory of the people",
  url: "https://shulisnameshub.com/colette-meaning/"
}, {
  letter: "C",
  name: "Collins",
  meaning: "Victory of the people",
  url: "https://shulisnameshub.com/collins-meaning/"
}, {
  letter: "C",
  name: "Cora",
  meaning: "Maiden",
  url: "https://shulisnameshub.com/cora-meaning/"
}, {
  letter: "C",
  name: "Coraline",
  meaning: "Maiden",
  url: "https://shulisnameshub.com/coraline-meaning/"
}, {
  letter: "C",
  name: "Cordelia",
  meaning: "Heart",
  url: "https://shulisnameshub.com/cordelia-meaning/"
}, {
  letter: "C",
  name: "Corinne",
  meaning: "Maiden",
  url: "https://shulisnameshub.com/corinne-meaning/"
}, {
  letter: "C",
  name: "Crystal",
  meaning: "Ice",
  url: "https://shulisnameshub.com/crystal-meaning/"
}, {
  letter: "C",
  name: "Cynthia",
  meaning: "Moon goddess",
  url: "https://shulisnameshub.com/cynthia-meaning/"
}, {
  letter: "D",
  name: "Dahlia",
  meaning: "Dahl's flower",
  url: "https://shulisnameshub.com/dahlia-meaning/"
}, {
  letter: "D",
  name: "Daisy",
  meaning: "Day's eye",
  url: "https://shulisnameshub.com/daisy-meaning/"
}, {
  letter: "D",
  name: "Dakota",
  meaning: "Friendly",
  url: "https://shulisnameshub.com/dakota-meaning/"
}, {
  letter: "D",
  name: "Dalary",
  meaning: "Unknown",
  url: "https://shulisnameshub.com/dalary-meaning/"
}, {
  letter: "D",
  name: "Daleyza",
  meaning: "Unknown",
  url: "https://shulisnameshub.com/daleyza-meaning/"
}, {
  letter: "D",
  name: "Dallas",
  meaning: "Skilled",
  url: "https://shulisnameshub.com/dallas-meaning/"
}, {
  letter: "D",
  name: "Dana",
  meaning: "God is my judge",
  url: "https://shulisnameshub.com/dana-meaning/"
}, {
  letter: "D",
  name: "Danica",
  meaning: "Morning star",
  url: "https://shulisnameshub.com/danica-meaning/"
}, {
  letter: "D",
  name: "Daniela",
  meaning: "God is my judge",
  url: "https://shulisnameshub.com/daniela-meaning/"
}, {
  letter: "D",
  name: "Daniella",
  meaning: "God is my judge",
  url: "https://shulisnameshub.com/daniella-meaning/"
}, {
  letter: "D",
  name: "Danielle",
  meaning: "God is my judge",
  url: "https://shulisnameshub.com/danielle-meaning/"
}, {
  letter: "D",
  name: "Danna",
  meaning: "God is my judge",
  url: "https://shulisnameshub.com/danna-meaning/"
}, {
  letter: "D",
  name: "Daphne",
  meaning: "Laurel tree",
  url: "https://shulisnameshub.com/daphne-meaning/"
}, {
  letter: "D",
  name: "Dara",
  meaning: "Pearl of wisdom",
  url: "https://shulisnameshub.com/dara-meaning/"
}, {
  letter: "D",
  name: "Darby",
  meaning: "Deer park",
  url: "https://shulisnameshub.com/darby-meaning/"
}, {
  letter: "D",
  name: "Darcy",
  meaning: "Dark",
  url: "https://shulisnameshub.com/darcy-meaning/"
}, {
  letter: "D",
  name: "Daria",
  meaning: "King-like",
  url: "https://shulisnameshub.com/daria-meaning/"
}, {
  letter: "D",
  name: "Davina",
  meaning: "Beloved",
  url: "https://shulisnameshub.com/davina-meaning/"
}, {
  letter: "D",
  name: "Dawn",
  meaning: "Daybreak",
  url: "https://shulisnameshub.com/dawn-meaning/"
}, {
  letter: "D",
  name: "Dayana",
  meaning: "Divine",
  url: "https://shulisnameshub.com/dayana-meaning/"
}, {
  letter: "D",
  name: "Deanna",
  meaning: "Divine",
  url: "https://shulisnameshub.com/deanna-meaning/"
}, {
  letter: "D",
  name: "Deborah",
  meaning: "Bee",
  url: "https://shulisnameshub.com/deborah-meaning/"
}, {
  letter: "D",
  name: "Delaney",
  meaning: "Dark challenger",
  url: "https://shulisnameshub.com/delaney-meaning/"
}, {
  letter: "D",
  name: "Delilah",
  meaning: "Delicate",
  url: "https://shulisnameshub.com/delilah-meaning/"
}, {
  letter: "D",
  name: "Della",
  meaning: "Noble",
  url: "https://shulisnameshub.com/della-meaning/"
}, {
  letter: "D",
  name: "Demi",
  meaning: "Half",
  url: "https://shulisnameshub.com/demi-meaning/"
}, {
  letter: "D",
  name: "Denise",
  meaning: "Follower of Dionysus",
  url: "https://shulisnameshub.com/denise-meaning/"
}, {
  letter: "D",
  name: "Desiree",
  meaning: "Desired",
  url: "https://shulisnameshub.com/desiree-meaning/"
}, {
  letter: "D",
  name: "Destiny",
  meaning: "Fate",
  url: "https://shulisnameshub.com/destiny-meaning/"
}, {
  letter: "D",
  name: "Devon",
  meaning: "Deep valley dweller",
  url: "https://shulisnameshub.com/devon-meaning/"
}, {
  letter: "D",
  name: "Diana",
  meaning: "Divine",
  url: "https://shulisnameshub.com/diana-meaning/"
}, {
  letter: "D",
  name: "Dianna",
  meaning: "Divine",
  url: "https://shulisnameshub.com/dianna-meaning/"
}, {
  letter: "D",
  name: "Dior",
  meaning: "Golden",
  url: "https://shulisnameshub.com/dior-meaning/"
}, {
  letter: "D",
  name: "Dixie",
  meaning: "Tenth",
  url: "https://shulisnameshub.com/dixie-meaning/"
}, {
  letter: "D",
  name: "Dora",
  meaning: "Gift",
  url: "https://shulisnameshub.com/dora-meaning/"
}, {
  letter: "D",
  name: "Dorothy",
  meaning: "Gift of God",
  url: "https://shulisnameshub.com/dorothy-meaning/"
}, {
  letter: "D",
  name: "Dream",
  meaning: "Vision",
  url: "https://shulisnameshub.com/dream-meaning/"
}, {
  letter: "D",
  name: "Dulce",
  meaning: "Sweet",
  url: "https://shulisnameshub.com/dulce-meaning/"
}, {
  letter: "D",
  name: "Dylan",
  meaning: "Son of the sea",
  url: "https://shulisnameshub.com/dylan-meaning/"
}, {
  letter: "E",
  name: "Eden",
  meaning: "Place of pleasure",
  url: "https://shulisnameshub.com/eden-meaning/"
}, {
  letter: "E",
  name: "Edith",
  meaning: "Prosperous in war",
  url: "https://shulisnameshub.com/edith-meaning/"
}, {
  letter: "E",
  name: "Eileen",
  meaning: "Bright, shining one",
  url: "https://shulisnameshub.com/eileen-meaning/"
}, {
  letter: "E",
  name: "Elaina",
  meaning: "Bright, shining light",
  url: "https://shulisnameshub.com/elaina-meaning/"
}, {
  letter: "E",
  name: "Elaine",
  meaning: "Bright, shining light",
  url: "https://shulisnameshub.com/elaine-meaning/"
}, {
  letter: "E",
  name: "Eleanor",
  meaning: "Bright, shining one",
  url: "https://shulisnameshub.com/eleanor-meaning/"
}, {
  letter: "E",
  name: "Elena",
  meaning: "Bright, shining light",
  url: "https://shulisnameshub.com/elena-meaning/"
}, {
  letter: "E",
  name: "Elian",
  meaning: "God has answered",
  url: "https://shulisnameshub.com/elian-meaning/"
}, {
  letter: "E",
  name: "Eliana",
  meaning: "God has answered",
  url: "https://shulisnameshub.com/eliana-meaning/"
}, {
  letter: "E",
  name: "Elise",
  meaning: "Pledged to God",
  url: "https://shulisnameshub.com/elise-meaning/"
}, {
  letter: "E",
  name: "Eliza",
  meaning: "Pledged to God",
  url: "https://shulisnameshub.com/eliza-meaning/"
}, {
  letter: "E",
  name: "Elizabeth",
  meaning: "Pledged to God",
  url: "https://shulisnameshub.com/elizabeth-meaning/"
}, {
  letter: "E",
  name: "Ella",
  meaning: "All, completely",
  url: "https://shulisnameshub.com/ella-meaning/"
}, {
  letter: "E",
  name: "Elle",
  meaning: "She",
  url: "https://shulisnameshub.com/elle-meaning/"
}, {
  letter: "E",
  name: "Ellen",
  meaning: "Bright, shining light",
  url: "https://shulisnameshub.com/ellen-meaning/"
}, {
  letter: "E",
  name: "Elliana",
  meaning: "God has answered",
  url: "https://shulisnameshub.com/elliana-meaning/"
}, {
  letter: "E",
  name: "Ellie",
  meaning: "Bright, shining one",
  url: "https://shulisnameshub.com/ellie-meaning/"
}, {
  letter: "E",
  name: "Elliot",
  meaning: "Jehovah is God",
  url: "https://shulisnameshub.com/elliot-meaning/"
}, {
  letter: "E",
  name: "Elliott",
  meaning: "Jehovah is God",
  url: "https://shulisnameshub.com/elliott-meaning/"
}, {
  letter: "E",
  name: "Ellis",
  meaning: "Benevolent",
  url: "https://shulisnameshub.com/ellis-meaning/"
}, {
  letter: "E",
  name: "Eloise",
  meaning: "Healthy, wide",
  url: "https://shulisnameshub.com/eloise-meaning/"
}, {
  letter: "E",
  name: "Elsa",
  meaning: "Pledged to God",
  url: "https://shulisnameshub.com/elsa-meaning/"
}, {
  letter: "E",
  name: "Elsie",
  meaning: "Pledged to God",
  url: "https://shulisnameshub.com/elsie-meaning/"
}, {
  letter: "E",
  name: "Ember",
  meaning: "Spark",
  url: "https://shulisnameshub.com/ember-meaning/"
}, {
  letter: "E",
  name: "Emely",
  meaning: "Rival",
  url: "https://shulisnameshub.com/emely-meaning/"
}, {
  letter: "E",
  name: "Emerson",
  meaning: "Son of Emery",
  url: "https://shulisnameshub.com/emerson-meaning/"
}, {
  letter: "E",
  name: "Emery",
  meaning: "Industrious",
  url: "https://shulisnameshub.com/emery-meaning/"
}, {
  letter: "E",
  name: "Emilia",
  meaning: "Rival",
  url: "https://shulisnameshub.com/emilia-meaning/"
}, {
  letter: "E",
  name: "Emily",
  meaning: "Rival",
  url: "https://shulisnameshub.com/emily-meaning/"
}, {
  letter: "E",
  name: "Emma",
  meaning: "Universal",
  url: "https://shulisnameshub.com/emma-meaning/"
}, {
  letter: "E",
  name: "Emmaline",
  meaning: "Universal",
  url: "https://shulisnameshub.com/emmaline-meaning/"
}, {
  letter: "E",
  name: "Emmalyn",
  meaning: "Universal",
  url: "https://shulisnameshub.com/emmalyn-meaning/"
}, {
  letter: "E",
  name: "Emmie",
  meaning: "Universal",
  url: "https://shulisnameshub.com/emmie-meaning/"
}, {
  letter: "E",
  name: "Emmy",
  meaning: "Universal",
  url: "https://shulisnameshub.com/emmy-meaning/"
}, {
  letter: "E",
  name: "Ensley",
  meaning: "One's own meadow",
  url: "https://shulisnameshub.com/ensley-meaning/"
}, {
  letter: "E",
  name: "Erica",
  meaning: "Eternal ruler",
  url: "https://shulisnameshub.com/erica-meaning/"
}, {
  letter: "E",
  name: "Erika",
  meaning: "Eternal ruler",
  url: "https://shulisnameshub.com/erika-meaning/"
}, {
  letter: "E",
  name: "Erin",
  meaning: "From Ireland",
  url: "https://shulisnameshub.com/erin-meaning/"
}, {
  letter: "E",
  name: "Esme",
  meaning: "Esteemed",
  url: "https://shulisnameshub.com/esme-meaning/"
}, {
  letter: "E",
  name: "Esmeralda",
  meaning: "Emerald",
  url: "https://shulisnameshub.com/esmeralda-meaning/"
}, {
  letter: "E",
  name: "Estella",
  meaning: "Star",
  url: "https://shulisnameshub.com/estella-meaning/"
}, {
  letter: "E",
  name: "Estelle",
  meaning: "Star",
  url: "https://shulisnameshub.com/estelle-meaning/"
}, {
  letter: "E",
  name: "Esther",
  meaning: "Star",
  url: "https://shulisnameshub.com/esther-meaning/"
}, {
  letter: "E",
  name: "Estrella",
  meaning: "Star",
  url: "https://shulisnameshub.com/estrella-meaning/"
}, {
  letter: "E",
  name: "Etta",
  meaning: "Ruler of the home",
  url: "https://shulisnameshub.com/etta-meaning/"
}, {
  letter: "E",
  name: "Eva",
  meaning: "Life",
  url: "https://shulisnameshub.com/eva-meaning/"
}, {
  letter: "E",
  name: "Evangeline",
  meaning: "Bearer of good news",
  url: "https://shulisnameshub.com/evangeline-meaning/"
}, {
  letter: "E",
  name: "Eve",
  meaning: "Life",
  url: "https://shulisnameshub.com/eve-meaning/"
}, {
  letter: "E",
  name: "Evelyn",
  meaning: "Desired",
  url: "https://shulisnameshub.com/evelyn-meaning/"
}, {
  letter: "E",
  name: "Evelynn",
  meaning: "Desired",
  url: "https://shulisnameshub.com/evelynn-meaning/"
}, {
  letter: "E",
  name: "Everlee",
  meaning: "Boar meadow",
  url: "https://shulisnameshub.com/everlee-meaning/"
}, {
  letter: "E",
  name: "Everleigh",
  meaning: "Boar meadow",
  url: "https://shulisnameshub.com/everleigh-meaning/"
}, {
  letter: "E",
  name: "Everly",
  meaning: "Wild boar in woodland clearing",
  url: "https://shulisnameshub.com/everly-meaning/"
}, {
  letter: "E",
  name: "Evie",
  meaning: "Life",
  url: "https://shulisnameshub.com/evie-meaning/"
}, {
  letter: "F",
  name: "Faith",
  meaning: "Trust, belief",
  url: "https://shulisnameshub.com/faith-meaning/"
}, {
  letter: "F",
  name: "Fallon",
  meaning: "Leader",
  url: "https://shulisnameshub.com/fallon-meaning/"
}, {
  letter: "F",
  name: "Fatima",
  meaning: "Captivating",
  url: "https://shulisnameshub.com/fatima-meaning/"
}, {
  letter: "F",
  name: "Fay",
  meaning: "Fairy",
  url: "https://shulisnameshub.com/fay-meaning/"
}, {
  letter: "F",
  name: "Faye",
  meaning: "Fairy",
  url: "https://shulisnameshub.com/faye-meaning/"
}, {
  letter: "F",
  name: "Felicity",
  meaning: "Good fortune, happy",
  url: "https://shulisnameshub.com/felicity-meaning/"
}, {
  letter: "F",
  name: "Fern",
  meaning: "A green plant",
  url: "https://shulisnameshub.com/fern-meaning/"
}, {
  letter: "F",
  name: "Fernanda",
  meaning: "Adventurous",
  url: "https://shulisnameshub.com/fernanda-meaning/"
}, {
  letter: "F",
  name: "Finley",
  meaning: "Fair-haired hero",
  url: "https://shulisnameshub.com/finley-meaning/"
}, {
  letter: "F",
  name: "Fiona",
  meaning: "White, fair",
  url: "https://shulisnameshub.com/fiona-meaning/"
}, {
  letter: "F",
  name: "Flora",
  meaning: "Flower",
  url: "https://shulisnameshub.com/flora-meaning/"
}, {
  letter: "F",
  name: "Florence",
  meaning: "Flourishing",
  url: "https://shulisnameshub.com/florence-meaning/"
}, {
  letter: "F",
  name: "Frances",
  meaning: "From France",
  url: "https://shulisnameshub.com/frances-meaning/"
}, {
  letter: "F",
  name: "Francesca",
  meaning: "Free man",
  url: "https://shulisnameshub.com/francesca-meaning/"
}, {
  letter: "F",
  name: "Frankie",
  meaning: "Free man",
  url: "https://shulisnameshub.com/frankie-meaning/"
}, {
  letter: "F",
  name: "Freya",
  meaning: "Noble lady",
  url: "https://shulisnameshub.com/freya-meaning/"
}, {
  letter: "F",
  name: "Freyja",
  meaning: "Lady",
  url: "https://shulisnameshub.com/freyja-meaning/"
}, {
  letter: "F",
  name: "Frida",
  meaning: "Peace",
  url: "https://shulisnameshub.com/frida-meaning/"
}, {
  letter: "G",
  name: "Gabriela",
  meaning: "God is my strength",
  url: "https://shulisnameshub.com/gabriela-meaning/"
}, {
  letter: "G",
  name: "Gabriella",
  meaning: "God is my strength",
  url: "https://shulisnameshub.com/gabriella-meaning/"
}, {
  letter: "G",
  name: "Gabrielle",
  meaning: "God is my strength",
  url: "https://shulisnameshub.com/gabrielle-meaning/"
}, {
  letter: "G",
  name: "Gia",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/gia-meaning/"
}, {
  letter: "G",
  name: "Giada",
  meaning: "Jade",
  url: "https://shulisnameshub.com/giada-meaning/"
}, {
  letter: "G",
  name: "Giana",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/giana-meaning/"
}, {
  letter: "G",
  name: "Gianna",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/gianna-meaning/"
}, {
  letter: "G",
  name: "Giavana",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/giavana-meaning/"
}, {
  letter: "G",
  name: "Gemma",
  meaning: "Precious stone",
  url: "https://shulisnameshub.com/gemma-meaning/"
}, {
  letter: "G",
  name: "Genevieve",
  meaning: "Woman of the family",
  url: "https://shulisnameshub.com/genevieve-meaning/"
}, {
  letter: "G",
  name: "Georgia",
  meaning: "Farmer",
  url: "https://shulisnameshub.com/georgia-meaning/"
}, {
  letter: "G",
  name: "Georgina",
  meaning: "Farmer",
  url: "https://shulisnameshub.com/georgina-meaning/"
}, {
  letter: "G",
  name: "Geraldine",
  meaning: "Ruler with a spear",
  url: "https://shulisnameshub.com/geraldine-meaning/"
}, {
  letter: "G",
  name: "Giselle",
  meaning: "Pledge",
  url: "https://shulisnameshub.com/giselle-meaning/"
}, {
  letter: "G",
  name: "Giuliana",
  meaning: "Youthful",
  url: "https://shulisnameshub.com/giuliana-meaning/"
}, {
  letter: "G",
  name: "Gloria",
  meaning: "Glory",
  url: "https://shulisnameshub.com/gloria-meaning/"
}, {
  letter: "G",
  name: "Goldie",
  meaning: "Made of gold",
  url: "https://shulisnameshub.com/goldie-meaning/"
}, {
  letter: "G",
  name: "Grace",
  meaning: "Charm, goodness",
  url: "https://shulisnameshub.com/grace-meaning/"
}, {
  letter: "G",
  name: "Gracelyn",
  meaning: "Grace",
  url: "https://shulisnameshub.com/gracelyn-meaning/"
}, {
  letter: "G",
  name: "Gracelynn",
  meaning: "Grace",
  url: "https://shulisnameshub.com/gracelynn-meaning/"
}, {
  letter: "G",
  name: "Gracie",
  meaning: "Grace",
  url: "https://shulisnameshub.com/gracie-meaning/"
}, {
  letter: "G",
  name: "Greta",
  meaning: "Pearl",
  url: "https://shulisnameshub.com/greta-meaning/"
}, {
  letter: "G",
  name: "Gretchen",
  meaning: "Little pearl",
  url: "https://shulisnameshub.com/gretchen-meaning/"
}, {
  letter: "G",
  name: "Guadalupe",
  meaning: "Valley of the wolf",
  url: "https://shulisnameshub.com/guadalupe-meaning/"
}, {
  letter: "G",
  name: "Gwen",
  meaning: "White, holy",
  url: "https://shulisnameshub.com/gwen-meaning/"
}, {
  letter: "G",
  name: "Gwendolyn",
  meaning: "White ring",
  url: "https://shulisnameshub.com/gwendolyn-meaning/"
}, {
  letter: "G",
  name: "Gwyneth",
  meaning: "Happiness",
  url: "https://shulisnameshub.com/gwyneth-meaning/"
}, {
  letter: "H",
  name: "Hadassah",
  meaning: "Myrtle tree",
  url: "https://shulisnameshub.com/hadassah-meaning/"
}, {
  letter: "H",
  name: "Hadlee",
  meaning: "Heather field",
  url: "https://shulisnameshub.com/hadlee-meaning/"
}, {
  letter: "H",
  name: "Hadley",
  meaning: "Heather field",
  url: "https://shulisnameshub.com/hadley-meaning/"
}, {
  letter: "H",
  name: "Hailee",
  meaning: "Hay meadow",
  url: "https://shulisnameshub.com/hailee-meaning/"
}, {
  letter: "H",
  name: "Hailey",
  meaning: "Hay meadow",
  url: "https://shulisnameshub.com/hailey-meaning/"
}, {
  letter: "H",
  name: "Haisley",
  meaning: "Hazel meadow",
  url: "https://shulisnameshub.com/haisley-meaning/"
}, {
  letter: "H",
  name: "Haley",
  meaning: "Hay meadow",
  url: "https://shulisnameshub.com/haley-meaning/"
}, {
  letter: "H",
  name: "Halle",
  meaning: "Heroine",
  url: "https://shulisnameshub.com/halle-meaning/"
}, {
  letter: "H",
  name: "Hallie",
  meaning: "Dweller at the hall meadow",
  url: "https://shulisnameshub.com/hallie-meaning/"
}, {
  letter: "H",
  name: "Hana",
  meaning: "Flower",
  url: "https://shulisnameshub.com/hana-meaning/"
}, {
  letter: "H",
  name: "Hanna",
  meaning: "Grace",
  url: "https://shulisnameshub.com/hanna-meaning/"
}, {
  letter: "H",
  name: "Hannah",
  meaning: "Grace",
  url: "https://shulisnameshub.com/hannah-meaning/"
}, {
  letter: "H",
  name: "Harlee",
  meaning: "Hare meadow",
  url: "https://shulisnameshub.com/harlee-meaning/"
}, {
  letter: "H",
  name: "Harleigh",
  meaning: "Hare meadow",
  url: "https://shulisnameshub.com/harleigh-meaning/"
}, {
  letter: "H",
  name: "Harley",
  meaning: "Hare meadow",
  url: "https://shulisnameshub.com/harley-meaning/"
}, {
  letter: "H",
  name: "Harlow",
  meaning: "Army hill",
  url: "https://shulisnameshub.com/harlow-meaning/"
}, {
  letter: "H",
  name: "Harmony",
  meaning: "Unity",
  url: "https://shulisnameshub.com/harmony-meaning/"
}, {
  letter: "H",
  name: "Harper",
  meaning: "Harp player",
  url: "https://shulisnameshub.com/harper-meaning/"
}, {
  letter: "H",
  name: "Hattie",
  meaning: "Home ruler",
  url: "https://shulisnameshub.com/hattie-meaning/"
}, {
  letter: "H",
  name: "Haven",
  meaning: "Safe place",
  url: "https://shulisnameshub.com/haven-meaning/"
}, {
  letter: "H",
  name: "Hayden",
  meaning: "Heather-grown hill",
  url: "https://shulisnameshub.com/hayden-meaning/"
}, {
  letter: "H",
  name: "Haylee",
  meaning: "Hay meadow",
  url: "https://shulisnameshub.com/haylee-meaning/"
}, {
  letter: "H",
  name: "Hayley",
  meaning: "Hay meadow",
  url: "https://shulisnameshub.com/hayley-meaning/"
}, {
  letter: "H",
  name: "Hazel",
  meaning: "The hazel tree",
  url: "https://shulisnameshub.com/hazel-meaning/"
}, {
  letter: "H",
  name: "Heather",
  meaning: "Flowering plant",
  url: "https://shulisnameshub.com/heather-meaning/"
}, {
  letter: "H",
  name: "Heaven",
  meaning: "Paradise",
  url: "https://shulisnameshub.com/heaven-meaning/"
}, {
  letter: "H",
  name: "Heidi",
  meaning: "Of noble birth",
  url: "https://shulisnameshub.com/heidi-meaning/"
}, {
  letter: "H",
  name: "Helen",
  meaning: "Bright, shining light",
  url: "https://shulisnameshub.com/helen-meaning/"
}, {
  letter: "H",
  name: "Helena",
  meaning: "Bright, shining light",
  url: "https://shulisnameshub.com/helena-meaning/"
}, {
  letter: "H",
  name: "Henley",
  meaning: "High meadow",
  url: "https://shulisnameshub.com/henley-meaning/"
}, {
  letter: "H",
  name: "Hensley",
  meaning: "Woodland clearing",
  url: "https://shulisnameshub.com/hensley-meaning/"
}, {
  letter: "H",
  name: "Holly",
  meaning: "The holly tree",
  url: "https://shulisnameshub.com/holly-meaning/"
}, {
  letter: "H",
  name: "Hope",
  meaning: "Desire of fulfillment",
  url: "https://shulisnameshub.com/hope-meaning/"
}, {
  letter: "H",
  name: "Hunter",
  meaning: "One who hunts",
  url: "https://shulisnameshub.com/hunter-meaning/"
}, {
  letter: "I",
  name: "Ida",
  meaning: "Industrious",
  url: "https://shulisnameshub.com/ida-meaning/"
}, {
  letter: "I",
  name: "Iliana",
  meaning: "Bright",
  url: "https://shulisnameshub.com/iliana-meaning/"
}, {
  letter: "I",
  name: "Imani",
  meaning: "Faith",
  url: "https://shulisnameshub.com/imani-meaning/"
}, {
  letter: "I",
  name: "Imogen",
  meaning: "Maiden",
  url: "https://shulisnameshub.com/imogen-meaning/"
}, {
  letter: "I",
  name: "India",
  meaning: "From the Indus River",
  url: "https://shulisnameshub.com/india-meaning/"
}, {
  letter: "I",
  name: "Indie",
  meaning: "Independent",
  url: "https://shulisnameshub.com/indie-meaning/"
}, {
  letter: "I",
  name: "Indigo",
  meaning: "Indian dye",
  url: "https://shulisnameshub.com/indigo-meaning/"
}, {
  letter: "I",
  name: "Ines",
  meaning: "Pure",
  url: "https://shulisnameshub.com/ines-meaning/"
}, {
  letter: "I",
  name: "Ingrid",
  meaning: "Fair, beautiful",
  url: "https://shulisnameshub.com/ingrid-meaning/"
}, {
  letter: "I",
  name: "Irene",
  meaning: "Peace",
  url: "https://shulisnameshub.com/irene-meaning/"
}, {
  letter: "I",
  name: "Iris",
  meaning: "Rainbow",
  url: "https://shulisnameshub.com/iris-meaning/"
}, {
  letter: "I",
  name: "Isabel",
  meaning: "Pledged to God",
  url: "https://shulisnameshub.com/isabel-meaning/"
}, {
  letter: "I",
  name: "Isabella",
  meaning: "Pledged to God",
  url: "https://shulisnameshub.com/isabella-meaning/"
}, {
  letter: "I",
  name: "Isabelle",
  meaning: "Pledged to God",
  url: "https://shulisnameshub.com/isabelle-meaning/"
}, {
  letter: "I",
  name: "Isadora",
  meaning: "Gift of Isis",
  url: "https://shulisnameshub.com/isadora-meaning/"
}, {
  letter: "I",
  name: "Isla",
  meaning: "Island",
  url: "https://shulisnameshub.com/isla-meaning/"
}, {
  letter: "I",
  name: "Itzel",
  meaning: "Rainbow lady",
  url: "https://shulisnameshub.com/itzel-meaning/"
}, {
  letter: "I",
  name: "Ivanna",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/ivanna-meaning/"
}, {
  letter: "I",
  name: "Ivory",
  meaning: "White, pure",
  url: "https://shulisnameshub.com/ivory-meaning/"
}, {
  letter: "I",
  name: "Ivy",
  meaning: "Faithfulness",
  url: "https://shulisnameshub.com/ivy-meaning/"
}, {
  letter: "I",
  name: "Iyanna",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/iyanna-meaning/"
}, {
  letter: "I",
  name: "Izabella",
  meaning: "Pledged to God",
  url: "https://shulisnameshub.com/izabella-meaning/"
}, {
  letter: "J",
  name: "Jacqueline",
  meaning: "Supplanter",
  url: "https://shulisnameshub.com/jacqueline-meaning/"
}, {
  letter: "J",
  name: "Jada",
  meaning: "Jade",
  url: "https://shulisnameshub.com/jada-meaning/"
}, {
  letter: "J",
  name: "Jade",
  meaning: "Stone of the side",
  url: "https://shulisnameshub.com/jade-meaning/"
}, {
  letter: "J",
  name: "Jadyn",
  meaning: "Thankful",
  url: "https://shulisnameshub.com/jadyn-meaning/"
}, {
  letter: "J",
  name: "Jaelyn",
  meaning: "Supplanter",
  url: "https://shulisnameshub.com/jaelyn-meaning/"
}, {
  letter: "J",
  name: "Jaelynn",
  meaning: "Supplanter",
  url: "https://shulisnameshub.com/jaelynn-meaning/"
}, {
  letter: "J",
  name: "Jaliyah",
  meaning: "Exalted",
  url: "https://shulisnameshub.com/jaliyah-meaning/"
}, {
  letter: "J",
  name: "Jamie",
  meaning: "Supplanter",
  url: "https://shulisnameshub.com/jamie-meaning/"
}, {
  letter: "J",
  name: "Jane",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/jane-meaning/"
}, {
  letter: "J",
  name: "Janelle",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/janelle-meaning/"
}, {
  letter: "J",
  name: "Janessa",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/janessa-meaning/"
}, {
  letter: "J",
  name: "Janet",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/janet-meaning/"
}, {
  letter: "J",
  name: "Janiyah",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/janiyah-meaning/"
}, {
  letter: "J",
  name: "Jasmine",
  meaning: "Gift from God",
  url: "https://shulisnameshub.com/jasmine-meaning/"
}, {
  letter: "J",
  name: "Jaycee",
  meaning: "Blue crested bird",
  url: "https://shulisnameshub.com/jaycee-meaning/"
}, {
  letter: "J",
  name: "Jayda",
  meaning: "Jade",
  url: "https://shulisnameshub.com/jayda-meaning/"
}, {
  letter: "J",
  name: "Jayde",
  meaning: "Jade",
  url: "https://shulisnameshub.com/jayde-meaning/"
}, {
  letter: "J",
  name: "Jayla",
  meaning: "To ascend",
  url: "https://shulisnameshub.com/jayla-meaning/"
}, {
  letter: "J",
  name: "Jaylah",
  meaning: "To ascend",
  url: "https://shulisnameshub.com/jaylah-meaning/"
}, {
  letter: "J",
  name: "Jaylee",
  meaning: "Blue jay",
  url: "https://shulisnameshub.com/jaylee-meaning/"
}, {
  letter: "J",
  name: "Jayleen",
  meaning: "Blue jay",
  url: "https://shulisnameshub.com/jayleen-meaning/"
}, {
  letter: "J",
  name: "Jaylene",
  meaning: "Blue jay",
  url: "https://shulisnameshub.com/jaylene-meaning/"
}, {
  letter: "J",
  name: "Jazlyn",
  meaning: "Jasmine",
  url: "https://shulisnameshub.com/jazlyn-meaning/"
}, {
  letter: "J",
  name: "Jazlynn",
  meaning: "Jasmine",
  url: "https://shulisnameshub.com/jazlynn-meaning/"
}, {
  letter: "J",
  name: "Jazmin",
  meaning: "Jasmine flower",
  url: "https://shulisnameshub.com/jazmin-meaning/"
}, {
  letter: "J",
  name: "Jazmine",
  meaning: "Jasmine flower",
  url: "https://shulisnameshub.com/jazmine-meaning/"
}, {
  letter: "J",
  name: "Jean",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/jean-meaning/"
}, {
  letter: "J",
  name: "Jenna",
  meaning: "White shadow",
  url: "https://shulisnameshub.com/jenna-meaning/"
}, {
  letter: "J",
  name: "Jennifer",
  meaning: "White shadow",
  url: "https://shulisnameshub.com/jennifer-meaning/"
}, {
  letter: "J",
  name: "Jessica",
  meaning: "God beholds",
  url: "https://shulisnameshub.com/jessica-meaning/"
}, {
  letter: "J",
  name: "Jessie",
  meaning: "God beholds",
  url: "https://shulisnameshub.com/jessie-meaning/"
}, {
  letter: "J",
  name: "Jewel",
  meaning: "Precious stone",
  url: "https://shulisnameshub.com/jewel-meaning/"
}, {
  letter: "J",
  name: "Jill",
  meaning: "Youthful",
  url: "https://shulisnameshub.com/jill-meaning/"
}, {
  letter: "J",
  name: "Jillian",
  meaning: "Youthful",
  url: "https://shulisnameshub.com/jillian-meaning/"
}, {
  letter: "J",
  name: "Jimena",
  meaning: "Heard",
  url: "https://shulisnameshub.com/jimena-meaning/"
}, {
  letter: "J",
  name: "Joanna",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/joanna-meaning/"
}, {
  letter: "J",
  name: "Jocelyn",
  meaning: "Member of the Gauts",
  url: "https://shulisnameshub.com/jocelyn-meaning/"
}, {
  letter: "J",
  name: "Joelle",
  meaning: "Jehovah is God",
  url: "https://shulisnameshub.com/joelle-meaning/"
}, {
  letter: "J",
  name: "Johanna",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/johanna-meaning/"
}, {
  letter: "J",
  name: "Jolene",
  meaning: "Pretty",
  url: "https://shulisnameshub.com/jolene-meaning/"
}, {
  letter: "J",
  name: "Jolie",
  meaning: "Pretty",
  url: "https://shulisnameshub.com/jolie-meaning/"
}, {
  letter: "J",
  name: "Jordan",
  meaning: "To flow down",
  url: "https://shulisnameshub.com/jordan-meaning/"
}, {
  letter: "J",
  name: "Jordyn",
  meaning: "To flow down",
  url: "https://shulisnameshub.com/jordyn-meaning/"
}, {
  letter: "J",
  name: "Josephine",
  meaning: "Jehovah increases",
  url: "https://shulisnameshub.com/josephine-meaning/"
}, {
  letter: "J",
  name: "Josie",
  meaning: "God will add",
  url: "https://shulisnameshub.com/josie-meaning/"
}, {
  letter: "J",
  name: "Journee",
  meaning: "A journey",
  url: "https://shulisnameshub.com/journee-meaning/"
}, {
  letter: "J",
  name: "Journey",
  meaning: "A journey",
  url: "https://shulisnameshub.com/journey-meaning/"
}, {
  letter: "J",
  name: "Joy",
  meaning: "Happiness",
  url: "https://shulisnameshub.com/joy-meaning/"
}, {
  letter: "J",
  name: "Joyce",
  meaning: "Merry",
  url: "https://shulisnameshub.com/joyce-meaning/"
}, {
  letter: "J",
  name: "Judith",
  meaning: "Woman from Judea",
  url: "https://shulisnameshub.com/judith-meaning/"
}, {
  letter: "J",
  name: "Julia",
  meaning: "Youthful",
  url: "https://shulisnameshub.com/julia-meaning/"
}, {
  letter: "J",
  name: "Juliana",
  meaning: "Youthful",
  url: "https://shulisnameshub.com/juliana-meaning/"
}, {
  letter: "J",
  name: "Julianna",
  meaning: "Youthful",
  url: "https://shulisnameshub.com/julianna-meaning/"
}, {
  letter: "J",
  name: "Julie",
  meaning: "Youthful",
  url: "https://shulisnameshub.com/julie-meaning/"
}, {
  letter: "J",
  name: "Juliet",
  meaning: "Youthful",
  url: "https://shulisnameshub.com/juliet-meaning/"
}, {
  letter: "J",
  name: "Juliette",
  meaning: "Youthful",
  url: "https://shulisnameshub.com/juliette-meaning/"
}, {
  letter: "J",
  name: "June",
  meaning: "Young",
  url: "https://shulisnameshub.com/june-meaning/"
}, {
  letter: "J",
  name: "Juniper",
  meaning: "Young",
  url: "https://shulisnameshub.com/juniper-meaning/"
}, {
  letter: "J",
  name: "Justice",
  meaning: "Righteous",
  url: "https://shulisnameshub.com/justice-meaning/"
}, {
  letter: "K",
  name: "Kadence",
  meaning: "Rhythm",
  url: "https://shulisnameshub.com/kadence-meaning/"
}, {
  letter: "K",
  name: "Kaia",
  meaning: "To rejoice",
  url: "https://shulisnameshub.com/kaia-meaning/"
}, {
  letter: "K",
  name: "Kailani",
  meaning: "Sea and sky",
  url: "https://shulisnameshub.com/kailani-meaning/"
}, {
  letter: "K",
  name: "Kailey",
  meaning: "Laurel, crown",
  url: "https://shulisnameshub.com/kailey-meaning/"
}, {
  letter: "K",
  name: "Kairi",
  meaning: "Sea",
  url: "https://shulisnameshub.com/kairi-meaning/"
}, {
  letter: "K",
  name: "Kaitlyn",
  meaning: "Pure",
  url: "https://shulisnameshub.com/kaitlyn-meaning/"
}, {
  letter: "K",
  name: "Kalani",
  meaning: "The heavens",
  url: "https://shulisnameshub.com/kalani-meaning/"
}, {
  letter: "K",
  name: "Kali",
  meaning: "Black one",
  url: "https://shulisnameshub.com/kali-meaning/"
}, {
  letter: "K",
  name: "Kaliyah",
  meaning: "Beloved",
  url: "https://shulisnameshub.com/kaliyah-meaning/"
}, {
  letter: "K",
  name: "Kallie",
  meaning: "Beautiful",
  url: "https://shulisnameshub.com/kallie-meaning/"
}, {
  letter: "K",
  name: "Kamila",
  meaning: "Perfect",
  url: "https://shulisnameshub.com/kamila-meaning/"
}, {
  letter: "K",
  name: "Kamilla",
  meaning: "Perfect",
  url: "https://shulisnameshub.com/kamilla-meaning/"
}, {
  letter: "K",
  name: "Kamryn",
  meaning: "Crooked nose",
  url: "https://shulisnameshub.com/kamryn-meaning/"
}, {
  letter: "K",
  name: "Kara",
  meaning: "Dear",
  url: "https://shulisnameshub.com/kara-meaning/"
}, {
  letter: "K",
  name: "Karen",
  meaning: "Pure",
  url: "https://shulisnameshub.com/karen-meaning/"
}, {
  letter: "K",
  name: "Karina",
  meaning: "Pure",
  url: "https://shulisnameshub.com/karina-meaning/"
}, {
  letter: "K",
  name: "Karla",
  meaning: "Free man",
  url: "https://shulisnameshub.com/karla-meaning/"
}, {
  letter: "K",
  name: "Karlee",
  meaning: "Free man",
  url: "https://shulisnameshub.com/karlee-meaning/"
}, {
  letter: "K",
  name: "Karsyn",
  meaning: "Son of Carr",
  url: "https://shulisnameshub.com/karsyn-meaning/"
}, {
  letter: "K",
  name: "Karter",
  meaning: "Cart driver",
  url: "https://shulisnameshub.com/karter-meaning/"
}, {
  letter: "K",
  name: "Kassidy",
  meaning: "Curly-haired",
  url: "https://shulisnameshub.com/kassidy-meaning/"
}, {
  letter: "K",
  name: "Kate",
  meaning: "Pure",
  url: "https://shulisnameshub.com/kate-meaning/"
}, {
  letter: "K",
  name: "Katelyn",
  meaning: "Pure",
  url: "https://shulisnameshub.com/katelyn-meaning/"
}, {
  letter: "K",
  name: "Katherine",
  meaning: "Pure",
  url: "https://shulisnameshub.com/katherine-meaning/"
}, {
  letter: "K",
  name: "Kathleen",
  meaning: "Pure",
  url: "https://shulisnameshub.com/kathleen-meaning/"
}, {
  letter: "K",
  name: "Kathryn",
  meaning: "Pure",
  url: "https://shulisnameshub.com/kathryn-meaning/"
}, {
  letter: "K",
  name: "Katie",
  meaning: "Pure",
  url: "https://shulisnameshub.com/katie-meaning/"
}, {
  letter: "K",
  name: "Kayla",
  meaning: "Crown",
  url: "https://shulisnameshub.com/kayla-meaning/"
}, {
  letter: "K",
  name: "Kaylani",
  meaning: "Sea and sky",
  url: "https://shulisnameshub.com/kaylani-meaning/"
}, {
  letter: "K",
  name: "Kaylee",
  meaning: "Laurel, crown",
  url: "https://shulisnameshub.com/kaylee-meaning/"
}, {
  letter: "K",
  name: "Kayleigh",
  meaning: "Laurel, crown",
  url: "https://shulisnameshub.com/kayleigh-meaning/"
}, {
  letter: "K",
  name: "Kaylie",
  meaning: "Laurel, crown",
  url: "https://shulisnameshub.com/kaylie-meaning/"
}, {
  letter: "K",
  name: "Kaylin",
  meaning: "Pure",
  url: "https://shulisnameshub.com/kaylin-meaning/"
}, {
  letter: "K",
  name: "Kehlani",
  meaning: "Sea and sky",
  url: "https://shulisnameshub.com/kehlani-meaning/"
}, {
  letter: "K",
  name: "Keilani",
  meaning: "Glorious chief",
  url: "https://shulisnameshub.com/keilani-meaning/"
}, {
  letter: "K",
  name: "Keira",
  meaning: "Little dark one",
  url: "https://shulisnameshub.com/keira-meaning/"
}, {
  letter: "K",
  name: "Kelly",
  meaning: "War",
  url: "https://shulisnameshub.com/kelly-meaning/"
}, {
  letter: "K",
  name: "Kelsey",
  meaning: "Ship's victory",
  url: "https://shulisnameshub.com/kelsey-meaning/"
}, {
  letter: "K",
  name: "Kendall",
  meaning: "Valley of the River Kent",
  url: "https://shulisnameshub.com/kendall-meaning/"
}, {
  letter: "K",
  name: "Kendra",
  meaning: "Knowledge",
  url: "https://shulisnameshub.com/kendra-meaning/"
}, {
  letter: "K",
  name: "Kenia",
  meaning: "Mountain of light",
  url: "https://shulisnameshub.com/kenia-meaning/"
}, {
  letter: "K",
  name: "Kenna",
  meaning: "Born of fire",
  url: "https://shulisnameshub.com/kenna-meaning/"
}, {
  letter: "K",
  name: "Kennedy",
  meaning: "Misshapen head",
  url: "https://shulisnameshub.com/kennedy-meaning/"
}, {
  letter: "K",
  name: "Kensley",
  meaning: "Clearance",
  url: "https://shulisnameshub.com/kensley-meaning/"
}, {
  letter: "K",
  name: "Kenzie",
  meaning: "Fair one",
  url: "https://shulisnameshub.com/kenzie-meaning/"
}, {
  letter: "K",
  name: "Keyla",
  meaning: "Crown",
  url: "https://shulisnameshub.com/keyla-meaning/"
}, {
  letter: "K",
  name: "Kiana",
  meaning: "Divine",
  url: "https://shulisnameshub.com/kiana-meaning/"
}, {
  letter: "K",
  name: "Kiara",
  meaning: "Bright, clear",
  url: "https://shulisnameshub.com/kiara-meaning/"
}, {
  letter: "K",
  name: "Kiera",
  meaning: "Little dark one",
  url: "https://shulisnameshub.com/kiera-meaning/"
}, {
  letter: "K",
  name: "Kiley",
  meaning: "Boomerang",
  url: "https://shulisnameshub.com/kiley-meaning/"
}, {
  letter: "K",
  name: "Kimber",
  meaning: "Cyneburg's field",
  url: "https://shulisnameshub.com/kimber-meaning/"
}, {
  letter: "K",
  name: "Kimberly",
  meaning: "From the wood of the royal fortress",
  url: "https://shulisnameshub.com/kimberly-meaning/"
}, {
  letter: "K",
  name: "Kinsley",
  meaning: "King's meadow",
  url: "https://shulisnameshub.com/kinsley-meaning/"
}, {
  letter: "K",
  name: "Kira",
  meaning: "Sun",
  url: "https://shulisnameshub.com/kira-meaning/"
}, {
  letter: "K",
  name: "Kirsten",
  meaning: "Follower of Christ",
  url: "https://shulisnameshub.com/kirsten-meaning/"
}, {
  letter: "K",
  name: "Kora",
  meaning: "Maiden",
  url: "https://shulisnameshub.com/kora-meaning/"
}, {
  letter: "K",
  name: "Kori",
  meaning: "Maiden",
  url: "https://shulisnameshub.com/kori-meaning/"
}, {
  letter: "K",
  name: "Kyla",
  meaning: "Narrow",
  url: "https://shulisnameshub.com/kyla-meaning/"
}, {
  letter: "K",
  name: "Kylee",
  meaning: "Boomerang",
  url: "https://shulisnameshub.com/kylee-meaning/"
}, {
  letter: "K",
  name: "Kyleigh",
  meaning: "Boomerang",
  url: "https://shulisnameshub.com/kyleigh-meaning/"
}, {
  letter: "K",
  name: "Kylie",
  meaning: "Boomerang",
  url: "https://shulisnameshub.com/kylie-meaning/"
}, {
  letter: "K",
  name: "Kyra",
  meaning: "Lord",
  url: "https://shulisnameshub.com/kyra-meaning/"
}, {
  letter: "L",
  name: "Lacey",
  meaning: "From Lassy",
  url: "https://shulisnameshub.com/lacey-meaning/"
}, {
  letter: "L",
  name: "Laila",
  meaning: "Night beauty",
  url: "https://shulisnameshub.com/laila-meaning/"
}, {
  letter: "L",
  name: "Lailah",
  meaning: "Night beauty",
  url: "https://shulisnameshub.com/lailah-meaning/"
}, {
  letter: "L",
  name: "Lainey",
  meaning: "Bright, shining light",
  url: "https://shulisnameshub.com/lainey-meaning/"
}, {
  letter: "L",
  name: "Lana",
  meaning: "Afloat",
  url: "https://shulisnameshub.com/lana-meaning/"
}, {
  letter: "L",
  name: "Laney",
  meaning: "Bright, shining light",
  url: "https://shulisnameshub.com/laney-meaning/"
}, {
  letter: "L",
  name: "Lara",
  meaning: "Cheerful",
  url: "https://shulisnameshub.com/lara-meaning/"
}, {
  letter: "L",
  name: "Laura",
  meaning: "Bay laurel",
  url: "https://shulisnameshub.com/laura-meaning/"
}, {
  letter: "L",
  name: "Laurel",
  meaning: "The laurel tree",
  url: "https://shulisnameshub.com/laurel-meaning/"
}, {
  letter: "L",
  name: "Lauren",
  meaning: "Bay laurel",
  url: "https://shulisnameshub.com/lauren-meaning/"
}, {
  letter: "L",
  name: "Lauryn",
  meaning: "Bay laurel",
  url: "https://shulisnameshub.com/lauryn-meaning/"
}, {
  letter: "L",
  name: "Layla",
  meaning: "Night",
  url: "https://shulisnameshub.com/layla-meaning/"
}, {
  letter: "L",
  name: "Laylah",
  meaning: "Night",
  url: "https://shulisnameshub.com/laylah-meaning/"
}, {
  letter: "L",
  name: "Laylani",
  meaning: "Heavenly flower",
  url: "https://shulisnameshub.com/laylani-meaning/"
}, {
  letter: "L",
  name: "Lea",
  meaning: "Weary",
  url: "https://shulisnameshub.com/lea-meaning/"
}, {
  letter: "L",
  name: "Leah",
  meaning: "Weary",
  url: "https://shulisnameshub.com/leah-meaning/"
}, {
  letter: "L",
  name: "Leanna",
  meaning: "To bind",
  url: "https://shulisnameshub.com/leanna-meaning/"
}, {
  letter: "L",
  name: "Leia",
  meaning: "Weary",
  url: "https://shulisnameshub.com/leia-meaning/"
}, {
  letter: "L",
  name: "Leighton",
  meaning: "Meadow town",
  url: "https://shulisnameshub.com/leighton-meaning/"
}, {
  letter: "L",
  name: "Leila",
  meaning: "Night",
  url: "https://shulisnameshub.com/leila-meaning/"
}, {
  letter: "L",
  name: "Leilani",
  meaning: "Heavenly flowers",
  url: "https://shulisnameshub.com/leilani-meaning/"
}, {
  letter: "L",
  name: "Lena",
  meaning: "Bright one",
  url: "https://shulisnameshub.com/lena-meaning/"
}, {
  letter: "L",
  name: "Lennon",
  meaning: "Lover",
  url: "https://shulisnameshub.com/lennon-meaning/"
}, {
  letter: "L",
  name: "Lennox",
  meaning: "With many elm trees",
  url: "https://shulisnameshub.com/lennox-meaning/"
}, {
  letter: "L",
  name: "Leona",
  meaning: "Lioness",
  url: "https://shulisnameshub.com/leona-meaning/"
}, {
  letter: "L",
  name: "Leslie",
  meaning: "Garden of holly",
  url: "https://shulisnameshub.com/leslie-meaning/"
}, {
  letter: "L",
  name: "Lexi",
  meaning: "Defender of mankind",
  url: "https://shulisnameshub.com/lexi-meaning/"
}, {
  letter: "L",
  name: "Lexie",
  meaning: "Defender of mankind",
  url: "https://shulisnameshub.com/lexie-meaning/"
}, {
  letter: "L",
  name: "Leyla",
  meaning: "Night",
  url: "https://shulisnameshub.com/leyla-meaning/"
}, {
  letter: "L",
  name: "Lia",
  meaning: "Weary",
  url: "https://shulisnameshub.com/lia-meaning/"
}, {
  letter: "L",
  name: "Liana",
  meaning: "To bind",
  url: "https://shulisnameshub.com/liana-meaning/"
}, {
  letter: "L",
  name: "Liberty",
  meaning: "Freedom",
  url: "https://shulisnameshub.com/liberty-meaning/"
}, {
  letter: "L",
  name: "Lila",
  meaning: "Night",
  url: "https://shulisnameshub.com/lila-meaning/"
}, {
  letter: "L",
  name: "Lilah",
  meaning: "Night",
  url: "https://shulisnameshub.com/lilah-meaning/"
}, {
  letter: "L",
  name: "Lilian",
  meaning: "Lily",
  url: "https://shulisnameshub.com/lilian-meaning/"
}, {
  letter: "L",
  name: "Liliana",
  meaning: "Lily",
  url: "https://shulisnameshub.com/liliana-meaning/"
}, {
  letter: "L",
  name: "Lilianna",
  meaning: "Lily",
  url: "https://shulisnameshub.com/lilianna-meaning/"
}, {
  letter: "L",
  name: "Lilith",
  meaning: "Night monster",
  url: "https://shulisnameshub.com/lilith-meaning/"
}, {
  letter: "L",
  name: "Lillian",
  meaning: "Lily",
  url: "https://shulisnameshub.com/lillian-meaning/"
}, {
  letter: "L",
  name: "Lilliana",
  meaning: "Lily",
  url: "https://shulisnameshub.com/lilliana-meaning/"
}, {
  letter: "L",
  name: "Lillie",
  meaning: "Lily",
  url: "https://shulisnameshub.com/lillie-meaning/"
}, {
  letter: "L",
  name: "Lilly",
  meaning: "Lily",
  url: "https://shulisnameshub.com/lilly-meaning/"
}, {
  letter: "L",
  name: "Lily",
  meaning: "Purity",
  url: "https://shulisnameshub.com/lily-meaning/"
}, {
  letter: "L",
  name: "Lilyana",
  meaning: "Lily",
  url: "https://shulisnameshub.com/lilyana-meaning/"
}, {
  letter: "L",
  name: "Lina",
  meaning: "Tender",
  url: "https://shulisnameshub.com/lina-meaning/"
}, {
  letter: "L",
  name: "Linda",
  meaning: "Beautiful",
  url: "https://shulisnameshub.com/linda-meaning/"
}, {
  letter: "L",
  name: "Lindsay",
  meaning: "Island of linden trees",
  url: "https://shulisnameshub.com/lindsay-meaning/"
}, {
  letter: "L",
  name: "Lindsey",
  meaning: "Island of linden trees",
  url: "https://shulisnameshub.com/lindsey-meaning/"
}, {
  letter: "L",
  name: "Lisa",
  meaning: "Pledged to God",
  url: "https://shulisnameshub.com/lisa-meaning/"
}, {
  letter: "L",
  name: "Liv",
  meaning: "Life",
  url: "https://shulisnameshub.com/liv-meaning/"
}, {
  letter: "L",
  name: "Livia",
  meaning: "Envious",
  url: "https://shulisnameshub.com/livia-meaning/"
}, {
  letter: "L",
  name: "Logan",
  meaning: "Little hollow",
  url: "https://shulisnameshub.com/logan-meaning/"
}, {
  letter: "L",
  name: "Lola",
  meaning: "Lady of sorrows",
  url: "https://shulisnameshub.com/lola-meaning/"
}, {
  letter: "L",
  name: "London",
  meaning: "From the great river",
  url: "https://shulisnameshub.com/london-meaning/"
}, {
  letter: "L",
  name: "Londyn",
  meaning: "From the great river",
  url: "https://shulisnameshub.com/londyn-meaning/"
}, {
  letter: "L",
  name: "Lorelai",
  meaning: "Alluring",
  url: "https://shulisnameshub.com/lorelai-meaning/"
}, {
  letter: "L",
  name: "Lorelei",
  meaning: "Alluring",
  url: "https://shulisnameshub.com/lorelei-meaning/"
}, {
  letter: "L",
  name: "Loretta",
  meaning: "Laurel",
  url: "https://shulisnameshub.com/loretta-meaning/"
}, {
  letter: "L",
  name: "Lori",
  meaning: "Laurel",
  url: "https://shulisnameshub.com/lori-meaning/"
}, {
  letter: "L",
  name: "Lottie",
  meaning: "Free man",
  url: "https://shulisnameshub.com/lottie-meaning/"
}, {
  letter: "L",
  name: "Lotus",
  meaning: "Lotus flower",
  url: "https://shulisnameshub.com/lotus-meaning/"
}, {
  letter: "L",
  name: "Louisa",
  meaning: "Famous warrior",
  url: "https://shulisnameshub.com/louisa-meaning/"
}, {
  letter: "L",
  name: "Louise",
  meaning: "Famous warrior",
  url: "https://shulisnameshub.com/louise-meaning/"
}, {
  letter: "L",
  name: "Lucia",
  meaning: "Light",
  url: "https://shulisnameshub.com/lucia-meaning/"
}, {
  letter: "L",
  name: "Luciana",
  meaning: "Light",
  url: "https://shulisnameshub.com/luciana-meaning/"
}, {
  letter: "L",
  name: "Lucille",
  meaning: "Light",
  url: "https://shulisnameshub.com/lucille-meaning/"
}, {
  letter: "L",
  name: "Lucinda",
  meaning: "Light",
  url: "https://shulisnameshub.com/lucinda-meaning/"
}, {
  letter: "L",
  name: "Lucy",
  meaning: "Light",
  url: "https://shulisnameshub.com/lucy-meaning/"
}, {
  letter: "L",
  name: "Luisa",
  meaning: "Famous warrior",
  url: "https://shulisnameshub.com/luisa-meaning/"
}, {
  letter: "L",
  name: "Luna",
  meaning: "Moon",
  url: "https://shulisnameshub.com/luna-meaning/"
}, {
  letter: "L",
  name: "Luz",
  meaning: "Light",
  url: "https://shulisnameshub.com/luz-meaning/"
}, {
  letter: "L",
  name: "Lyanna",
  meaning: "To bind",
  url: "https://shulisnameshub.com/lyanna-meaning/"
}, {
  letter: "L",
  name: "Lydia",
  meaning: "Woman from Lydia",
  url: "https://shulisnameshub.com/lydia-meaning/"
}, {
  letter: "L",
  name: "Lyra",
  meaning: "Lyre",
  url: "https://shulisnameshub.com/lyra-meaning/"
}, {
  letter: "L",
  name: "Lyric",
  meaning: "Words of a song",
  url: "https://shulisnameshub.com/lyric-meaning/"
}, {
  letter: "M",
  name: "Mabel",
  meaning: "Lovable",
  url: "https://shulisnameshub.com/mabel-meaning/"
}, {
  letter: "M",
  name: "Maci",
  meaning: "Weapon",
  url: "https://shulisnameshub.com/maci-meaning/"
}, {
  letter: "M",
  name: "Macie",
  meaning: "Weapon",
  url: "https://shulisnameshub.com/macie-meaning/"
}, {
  letter: "M",
  name: "Mackenzie",
  meaning: "Son of Kenneth",
  url: "https://shulisnameshub.com/mackenzie-meaning/"
}, {
  letter: "M",
  name: "Macy",
  meaning: "Weapon",
  url: "https://shulisnameshub.com/macy-meaning/"
}, {
  letter: "M",
  name: "Madalyn",
  meaning: "High tower",
  url: "https://shulisnameshub.com/madalyn-meaning/"
}, {
  letter: "M",
  name: "Madeline",
  meaning: "High tower",
  url: "https://shulisnameshub.com/madeline-meaning/"
}, {
  letter: "M",
  name: "Madelyn",
  meaning: "High tower",
  url: "https://shulisnameshub.com/madelyn-meaning/"
}, {
  letter: "M",
  name: "Madelynn",
  meaning: "High tower",
  url: "https://shulisnameshub.com/madelynn-meaning/"
}, {
  letter: "M",
  name: "Madilyn",
  meaning: "High tower",
  url: "https://shulisnameshub.com/madilyn-meaning/"
}, {
  letter: "M",
  name: "Madisyn",
  meaning: "Son of Matthew",
  url: "https://shulisnameshub.com/madisyn-meaning/"
}, {
  letter: "M",
  name: "Madison",
  meaning: "Son of Matthew",
  url: "https://shulisnameshub.com/madison-meaning/"
}, {
  letter: "M",
  name: "Mae",
  meaning: "Bitter",
  url: "https://shulisnameshub.com/mae-meaning/"
}, {
  letter: "M",
  name: "Maeve",
  meaning: "She who intoxicates",
  url: "https://shulisnameshub.com/maeve-meaning/"
}, {
  letter: "M",
  name: "Maggie",
  meaning: "Pearl",
  url: "https://shulisnameshub.com/maggie-meaning/"
}, {
  letter: "M",
  name: "Magnolia",
  meaning: "Magnol's flower",
  url: "https://shulisnameshub.com/magnolia-meaning/"
}, {
  letter: "M",
  name: "Maia",
  meaning: "Mother",
  url: "https://shulisnameshub.com/maia-meaning/"
}, {
  letter: "M",
  name: "Maisie",
  meaning: "Pearl",
  url: "https://shulisnameshub.com/maisie-meaning/"
}, {
  letter: "M",
  name: "Makayla",
  meaning: "Who is like God?",
  url: "https://shulisnameshub.com/makayla-meaning/"
}, {
  letter: "M",
  name: "Makenna",
  meaning: "Child of Kenneth",
  url: "https://shulisnameshub.com/makenna-meaning/"
}, {
  letter: "M",
  name: "Makenzie",
  meaning: "Son of Kenneth",
  url: "https://shulisnameshub.com/makenzie-meaning/"
}, {
  letter: "M",
  name: "Malani",
  meaning: "Heavenly",
  url: "https://shulisnameshub.com/malani-meaning/"
}, {
  letter: "M",
  name: "Malaya",
  meaning: "Free",
  url: "https://shulisnameshub.com/malaya-meaning/"
}, {
  letter: "M",
  name: "Malaysia",
  meaning: "Land of the Malays",
  url: "https://shulisnameshub.com/malaysia-meaning/"
}, {
  letter: "M",
  name: "Maleah",
  meaning: "Bitter",
  url: "https://shulisnameshub.com/maleah-meaning/"
}, {
  letter: "M",
  name: "Malia",
  meaning: "Bitter",
  url: "https://shulisnameshub.com/malia-meaning/"
}, {
  letter: "M",
  name: "Maliyah",
  meaning: "Bitter",
  url: "https://shulisnameshub.com/maliyah-meaning/"
}, {
  letter: "M",
  name: "Mallory",
  meaning: "Unfortunate",
  url: "https://shulisnameshub.com/mallory-meaning/"
}, {
  letter: "M",
  name: "Mara",
  meaning: "Bitter",
  url: "https://shulisnameshub.com/mara-meaning/"
}, {
  letter: "M",
  name: "Marceline",
  meaning: "Little warrior",
  url: "https://shulisnameshub.com/marceline-meaning/"
}, {
  letter: "M",
  name: "Margaret",
  meaning: "Pearl",
  url: "https://shulisnameshub.com/margaret-meaning/"
}, {
  letter: "M",
  name: "Margo",
  meaning: "Pearl",
  url: "https://shulisnameshub.com/margo-meaning/"
}, {
  letter: "M",
  name: "Margot",
  meaning: "Pearl",
  url: "https://shulisnameshub.com/margot-meaning/"
}, {
  letter: "M",
  name: "Maria",
  meaning: "Of the sea",
  url: "https://shulisnameshub.com/maria-meaning/"
}, {
  letter: "M",
  name: "Mariah",
  meaning: "The Lord is my teacher",
  url: "https://shulisnameshub.com/mariah-meaning/"
}, {
  letter: "M",
  name: "Mariam",
  meaning: "Bitter",
  url: "https://shulisnameshub.com/mariam-meaning/"
}, {
  letter: "M",
  name: "Mariana",
  meaning: "Star of the sea",
  url: "https://shulisnameshub.com/mariana-meaning/"
}, {
  letter: "M",
  name: "Marianna",
  meaning: "Star of the sea",
  url: "https://shulisnameshub.com/marianna-meaning/"
}, {
  letter: "M",
  name: "Marie",
  meaning: "Star of the sea",
  url: "https://shulisnameshub.com/marie-meaning/"
}, {
  letter: "M",
  name: "Marilyn",
  meaning: "Star of the sea",
  url: "https://shulisnameshub.com/marilyn-meaning/"
}, {
  letter: "M",
  name: "Marina",
  meaning: "Of the sea",
  url: "https://shulisnameshub.com/marina-meaning/"
}, {
  letter: "M",
  name: "Marisol",
  meaning: "Sea and sun",
  url: "https://shulisnameshub.com/marisol-meaning/"
}, {
  letter: "M",
  name: "Marissa",
  meaning: "Of the sea",
  url: "https://shulisnameshub.com/marissa-meaning/"
}, {
  letter: "M",
  name: "Marlee",
  meaning: "Marshy meadow",
  url: "https://shulisnameshub.com/marlee-meaning/"
}, {
  letter: "M",
  name: "Marleigh",
  meaning: "Marshy meadow",
  url: "https://shulisnameshub.com/marleigh-meaning/"
}, {
  letter: "M",
  name: "Marley",
  meaning: "Marshy meadow",
  url: "https://shulisnameshub.com/marley-meaning/"
}, {
  letter: "M",
  name: "Martha",
  meaning: "Lady",
  url: "https://shulisnameshub.com/martha-meaning/"
}, {
  letter: "M",
  name: "Mary",
  meaning: "Bitter",
  url: "https://shulisnameshub.com/mary-meaning/"
}, {
  letter: "M",
  name: "Maryam",
  meaning: "Bitter",
  url: "https://shulisnameshub.com/maryam-meaning/"
}, {
  letter: "M",
  name: "Matilda",
  meaning: "Mighty in battle",
  url: "https://shulisnameshub.com/matilda-meaning/"
}, {
  letter: "M",
  name: "Mavis",
  meaning: "Songbird",
  url: "https://shulisnameshub.com/mavis-meaning/"
}, {
  letter: "M",
  name: "Maxine",
  meaning: "Greatest",
  url: "https://shulisnameshub.com/maxine-meaning/"
}, {
  letter: "M",
  name: "Maya",
  meaning: "Water",
  url: "https://shulisnameshub.com/maya-meaning/"
}, {
  letter: "M",
  name: "Mazie",
  meaning: "Pearl",
  url: "https://shulisnameshub.com/mazie-meaning/"
}, {
  letter: "M",
  name: "Mckenna",
  meaning: "Child of Kenneth",
  url: "https://shulisnameshub.com/mckenna-meaning/"
}, {
  letter: "M",
  name: "Mckenzie",
  meaning: "Son of Kenneth",
  url: "https://shulisnameshub.com/mckenzie-meaning/"
}, {
  letter: "M",
  name: "Mckinley",
  meaning: "Son of the fair warrior",
  url: "https://shulisnameshub.com/mckinley-meaning/"
}, {
  letter: "M",
  name: "Meadow",
  meaning: "Field of grass",
  url: "https://shulisnameshub.com/meadow-meaning/"
}, {
  letter: "M",
  name: "Meghan",
  meaning: "Pearl",
  url: "https://shulisnameshub.com/meghan-meaning/"
}, {
  letter: "M",
  name: "Melanie",
  meaning: "Dark",
  url: "https://shulisnameshub.com/melanie-meaning/"
}, {
  letter: "M",
  name: "Melany",
  meaning: "Dark",
  url: "https://shulisnameshub.com/melany-meaning/"
}, {
  letter: "M",
  name: "Melina",
  meaning: "Honey",
  url: "https://shulisnameshub.com/melina-meaning/"
}, {
  letter: "M",
  name: "Melissa",
  meaning: "Honeybee",
  url: "https://shulisnameshub.com/melissa-meaning/"
}, {
  letter: "M",
  name: "Melody",
  meaning: "Song",
  url: "https://shulisnameshub.com/melody-meaning/"
}, {
  letter: "M",
  name: "Mercy",
  meaning: "Compassion",
  url: "https://shulisnameshub.com/mercy-meaning/"
}, {
  letter: "M",
  name: "Meredith",
  meaning: "Great lord",
  url: "https://shulisnameshub.com/meredith-meaning/"
}, {
  letter: "M",
  name: "Mia",
  meaning: "Mine",
  url: "https://shulisnameshub.com/mia-meaning/"
}, {
  letter: "M",
  name: "Michaela",
  meaning: "Who is like God?",
  url: "https://shulisnameshub.com/michaela-meaning/"
}, {
  letter: "M",
  name: "Michelle",
  meaning: "Who is like God?",
  url: "https://shulisnameshub.com/michelle-meaning/"
}, {
  letter: "M",
  name: "Mikaela",
  meaning: "Who is like God?",
  url: "https://shulisnameshub.com/mikaela-meaning/"
}, {
  letter: "M",
  name: "Mikayla",
  meaning: "Who is like God?",
  url: "https://shulisnameshub.com/mikayla-meaning/"
}, {
  letter: "M",
  name: "Mila",
  meaning: "Gracious",
  url: "https://shulisnameshub.com/mila-meaning/"
}, {
  letter: "M",
  name: "Milan",
  meaning: "Gracious",
  url: "https://shulisnameshub.com/milan-meaning/"
}, {
  letter: "M",
  name: "Milana",
  meaning: "Gracious",
  url: "https://shulisnameshub.com/milana-meaning/"
}, {
  letter: "M",
  name: "Milani",
  meaning: "Gracious",
  url: "https://shulisnameshub.com/milani-meaning/"
}, {
  letter: "M",
  name: "Milena",
  meaning: "Gracious",
  url: "https://shulisnameshub.com/milena-meaning/"
}, {
  letter: "M",
  name: "Miley",
  meaning: "Smiley",
  url: "https://shulisnameshub.com/miley-meaning/"
}, {
  letter: "M",
  name: "Millie",
  meaning: "Gentle strength",
  url: "https://shulisnameshub.com/millie-meaning/"
}, {
  letter: "M",
  name: "Mina",
  meaning: "Love",
  url: "https://shulisnameshub.com/mina-meaning/"
}, {
  letter: "M",
  name: "Mira",
  meaning: "Admirable",
  url: "https://shulisnameshub.com/mira-meaning/"
}, {
  letter: "M",
  name: "Miracle",
  meaning: "Wonder",
  url: "https://shulisnameshub.com/miracle-meaning/"
}, {
  letter: "M",
  name: "Miranda",
  meaning: "Worthy of admiration",
  url: "https://shulisnameshub.com/miranda-meaning/"
}, {
  letter: "M",
  name: "Miriam",
  meaning: "Bitter",
  url: "https://shulisnameshub.com/miriam-meaning/"
}, {
  letter: "M",
  name: "Molly",
  meaning: "Star of the sea",
  url: "https://shulisnameshub.com/molly-meaning/"
}, {
  letter: "M",
  name: "Monica",
  meaning: "Advisor",
  url: "https://shulisnameshub.com/monica-meaning/"
}, {
  letter: "M",
  name: "Monroe",
  meaning: "Mouth of the Roe River",
  url: "https://shulisnameshub.com/monroe-meaning/"
}, {
  letter: "M",
  name: "Morgan",
  meaning: "Sea-born",
  url: "https://shulisnameshub.com/morgan-meaning/"
}, {
  letter: "M",
  name: "Mya",
  meaning: "Mine",
  url: "https://shulisnameshub.com/mya-meaning/"
}, {
  letter: "M",
  name: "Myra",
  meaning: "Myrrh",
  url: "https://shulisnameshub.com/myra-meaning/"
}, {
  letter: "N",
  name: "Nadia",
  meaning: "Hope",
  url: "https://shulisnameshub.com/nadia-meaning/"
}, {
  letter: "N",
  name: "Nala",
  meaning: "Stem",
  url: "https://shulisnameshub.com/nala-meaning/"
}, {
  letter: "N",
  name: "Nalani",
  meaning: "Serenity of the skies",
  url: "https://shulisnameshub.com/nalani-meaning/"
}, {
  letter: "N",
  name: "Nancy",
  meaning: "Grace",
  url: "https://shulisnameshub.com/nancy-meaning/"
}, {
  letter: "N",
  name: "Naomi",
  meaning: "Pleasantness",
  url: "https://shulisnameshub.com/naomi-meaning/"
}, {
  letter: "N",
  name: "Natalia",
  meaning: "Birthday of the Lord",
  url: "https://shulisnameshub.com/natalia-meaning/"
}, {
  letter: "N",
  name: "Natalie",
  meaning: "Birthday of the Lord",
  url: "https://shulisnameshub.com/natalie-meaning/"
}, {
  letter: "N",
  name: "Nataly",
  meaning: "Birthday of the Lord",
  url: "https://shulisnameshub.com/nataly-meaning/"
}, {
  letter: "N",
  name: "Natasha",
  meaning: "Birthday of the Lord",
  url: "https://shulisnameshub.com/natasha-meaning/"
}, {
  letter: "N",
  name: "Naya",
  meaning: "New",
  url: "https://shulisnameshub.com/naya-meaning/"
}, {
  letter: "N",
  name: "Nayeli",
  meaning: "I love you",
  url: "https://shulisnameshub.com/nayeli-meaning/"
}, {
  letter: "N",
  name: "Nia",
  meaning: "Purpose",
  url: "https://shulisnameshub.com/nia-meaning/"
}, {
  letter: "N",
  name: "Nicole",
  meaning: "People of victory",
  url: "https://shulisnameshub.com/nicole-meaning/"
}, {
  letter: "N",
  name: "Nicolette",
  meaning: "People of victory",
  url: "https://shulisnameshub.com/nicolette-meaning/"
}, {
  letter: "N",
  name: "Nina",
  meaning: "Little girl",
  url: "https://shulisnameshub.com/nina-meaning/"
}, {
  letter: "N",
  name: "Noa",
  meaning: "Movement",
  url: "https://shulisnameshub.com/noa-meaning/"
}, {
  letter: "N",
  name: "Noel",
  meaning: "Christmas",
  url: "https://shulisnameshub.com/noel-meaning/"
}, {
  letter: "N",
  name: "Noelle",
  meaning: "Christmas",
  url: "https://shulisnameshub.com/noelle-meaning/"
}, {
  letter: "N",
  name: "Noemi",
  meaning: "Pleasantness",
  url: "https://shulisnameshub.com/noemi-meaning/"
}, {
  letter: "N",
  name: "Nola",
  meaning: "Fair-shouldered",
  url: "https://shulisnameshub.com/nola-meaning/"
}, {
  letter: "N",
  name: "Noor",
  meaning: "Light",
  url: "https://shulisnameshub.com/noor-meaning/"
}, {
  letter: "N",
  name: "Nora",
  meaning: "Light",
  url: "https://shulisnameshub.com/nora-meaning/"
}, {
  letter: "N",
  name: "Norah",
  meaning: "Light",
  url: "https://shulisnameshub.com/norah-meaning/"
}, {
  letter: "N",
  name: "Nova",
  meaning: "New",
  url: "https://shulisnameshub.com/nova-meaning/"
}, {
  letter: "N",
  name: "Novah",
  meaning: "New",
  url: "https://shulisnameshub.com/novah-meaning/"
}, {
  letter: "N",
  name: "Novalee",
  meaning: "New meadow",
  url: "https://shulisnameshub.com/novalee-meaning/"
}, {
  letter: "N",
  name: "Nya",
  meaning: "Purpose",
  url: "https://shulisnameshub.com/nya-meaning/"
}, {
  letter: "N",
  name: "Nyla",
  meaning: "Winner",
  url: "https://shulisnameshub.com/nyla-meaning/"
}, {
  letter: "N",
  name: "Nylah",
  meaning: "Winner",
  url: "https://shulisnameshub.com/nylah-meaning/"
}, {
  letter: "O",
  name: "Oaklee",
  meaning: "Oak meadow",
  url: "https://shulisnameshub.com/oaklee-meaning/"
}, {
  letter: "O",
  name: "Oakleigh",
  meaning: "Oak meadow",
  url: "https://shulisnameshub.com/oakleigh-meaning/"
}, {
  letter: "O",
  name: "Oakley",
  meaning: "Oak clearing",
  url: "https://shulisnameshub.com/oakley-meaning/"
}, {
  letter: "O",
  name: "Oaklynn",
  meaning: "Oak meadow",
  url: "https://shulisnameshub.com/oaklynn-meaning/"
}, {
  letter: "O",
  name: "Octavia",
  meaning: "Eighth",
  url: "https://shulisnameshub.com/octavia-meaning/"
}, {
  letter: "O",
  name: "Odelia",
  meaning: "I will praise God",
  url: "https://shulisnameshub.com/odelia-meaning/"
}, {
  letter: "O",
  name: "Odette",
  meaning: "Wealthy",
  url: "https://shulisnameshub.com/odette-meaning/"
}, {
  letter: "O",
  name: "Olive",
  meaning: "Olive tree",
  url: "https://shulisnameshub.com/olive-meaning/"
}, {
  letter: "O",
  name: "Olivia",
  meaning: "Olive tree",
  url: "https://shulisnameshub.com/olivia-meaning/"
}, {
  letter: "O",
  name: "Opal",
  meaning: "Gemstone",
  url: "https://shulisnameshub.com/opal-meaning/"
}, {
  letter: "O",
  name: "Ophelia",
  meaning: "Help",
  url: "https://shulisnameshub.com/ophelia-meaning/"
}, {
  letter: "O",
  name: "Oriana",
  meaning: "Sunrise",
  url: "https://shulisnameshub.com/oriana-meaning/"
}, {
  letter: "P",
  name: "Paige",
  meaning: "Page to a lord",
  url: "https://shulisnameshub.com/paige-meaning/"
}, {
  letter: "P",
  name: "Paislee",
  meaning: "Church",
  url: "https://shulisnameshub.com/paislee-meaning/"
}, {
  letter: "P",
  name: "Paisley",
  meaning: "Church",
  url: "https://shulisnameshub.com/paisley-meaning/"
}, {
  letter: "P",
  name: "Paityn",
  meaning: "Fighting man's estate",
  url: "https://shulisnameshub.com/paityn-meaning/"
}, {
  letter: "P",
  name: "Paloma",
  meaning: "Dove",
  url: "https://shulisnameshub.com/paloma-meaning/"
}, {
  letter: "P",
  name: "Pandora",
  meaning: "All gifted",
  url: "https://shulisnameshub.com/pandora-meaning/"
}, {
  letter: "P",
  name: "Paola",
  meaning: "Small",
  url: "https://shulisnameshub.com/paola-meaning/"
}, {
  letter: "P",
  name: "Paris",
  meaning: "From Paris",
  url: "https://shulisnameshub.com/paris-meaning/"
}, {
  letter: "P",
  name: "Parker",
  meaning: "Park keeper",
  url: "https://shulisnameshub.com/parker-meaning/"
}, {
  letter: "P",
  name: "Patience",
  meaning: "Enduring",
  url: "https://shulisnameshub.com/patience-meaning/"
}, {
  letter: "P",
  name: "Patricia",
  meaning: "Noble",
  url: "https://shulisnameshub.com/patricia-meaning/"
}, {
  letter: "P",
  name: "Paula",
  meaning: "Small",
  url: "https://shulisnameshub.com/paula-meaning/"
}, {
  letter: "P",
  name: "Paulina",
  meaning: "Small",
  url: "https://shulisnameshub.com/paulina-meaning/"
}, {
  letter: "P",
  name: "Payton",
  meaning: "Fighting man's estate",
  url: "https://shulisnameshub.com/payton-meaning/"
}, {
  letter: "P",
  name: "Pearl",
  meaning: "Precious",
  url: "https://shulisnameshub.com/pearl-meaning/"
}, {
  letter: "P",
  name: "Penelope",
  meaning: "Weaver",
  url: "https://shulisnameshub.com/penelope-meaning/"
}, {
  letter: "P",
  name: "Penny",
  meaning: "Weaver",
  url: "https://shulisnameshub.com/penny-meaning/"
}, {
  letter: "P",
  name: "Persephone",
  meaning: "Bringer of death",
  url: "https://shulisnameshub.com/persephone-meaning/"
}, {
  letter: "P",
  name: "Peyton",
  meaning: "Fighting man's estate",
  url: "https://shulisnameshub.com/peyton-meaning/"
}, {
  letter: "P",
  name: "Phoebe",
  meaning: "Bright",
  url: "https://shulisnameshub.com/phoebe-meaning/"
}, {
  letter: "P",
  name: "Phoenix",
  meaning: "Dark red",
  url: "https://shulisnameshub.com/phoenix-meaning/"
}, {
  letter: "P",
  name: "Piper",
  meaning: "Pipe player",
  url: "https://shulisnameshub.com/piper-meaning/"
}, {
  letter: "P",
  name: "Pippa",
  meaning: "Lover of horses",
  url: "https://shulisnameshub.com/pippa-meaning/"
}, {
  letter: "P",
  name: "Poppy",
  meaning: "Red flower",
  url: "https://shulisnameshub.com/poppy-meaning/"
}, {
  letter: "P",
  name: "Presley",
  meaning: "Priest's meadow",
  url: "https://shulisnameshub.com/presley-meaning/"
}, {
  letter: "P",
  name: "Princess",
  meaning: "Royal daughter",
  url: "https://shulisnameshub.com/princess-meaning/"
}, {
  letter: "P",
  name: "Priscilla",
  meaning: "Ancient",
  url: "https://shulisnameshub.com/priscilla-meaning/"
}, {
  letter: "Q",
  name: "Queen",
  meaning: "Female ruler",
  url: "https://shulisnameshub.com/queen-meaning/"
}, {
  letter: "Q",
  name: "Queenie",
  meaning: "Queen",
  url: "https://shulisnameshub.com/queenie-meaning/"
}, {
  letter: "Q",
  name: "Quinn",
  meaning: "Counsel",
  url: "https://shulisnameshub.com/quinn-meaning/"
}, {
  letter: "Q",
  name: "Quintessa",
  meaning: "Fifth",
  url: "https://shulisnameshub.com/quintessa-meaning/"
}, {
  letter: "R",
  name: "Rachel",
  meaning: "Ewe",
  url: "https://shulisnameshub.com/rachel-meaning/"
}, {
  letter: "R",
  name: "Rae",
  meaning: "Ewe",
  url: "https://shulisnameshub.com/rae-meaning/"
}, {
  letter: "R",
  name: "Raegan",
  meaning: "Little ruler",
  url: "https://shulisnameshub.com/raegan-meaning/"
}, {
  letter: "R",
  name: "Raelyn",
  meaning: "Beam of light",
  url: "https://shulisnameshub.com/raelyn-meaning/"
}, {
  letter: "R",
  name: "Raelynn",
  meaning: "Beam of light",
  url: "https://shulisnameshub.com/raelynn-meaning/"
}, {
  letter: "R",
  name: "Raina",
  meaning: "Queen",
  url: "https://shulisnameshub.com/raina-meaning/"
}, {
  letter: "R",
  name: "Ramona",
  meaning: "Wise protector",
  url: "https://shulisnameshub.com/ramona-meaning/"
}, {
  letter: "R",
  name: "Raquel",
  meaning: "Ewe",
  url: "https://shulisnameshub.com/raquel-meaning/"
}, {
  letter: "R",
  name: "Raven",
  meaning: "Black bird",
  url: "https://shulisnameshub.com/raven-meaning/"
}, {
  letter: "R",
  name: "Raya",
  meaning: "Friend",
  url: "https://shulisnameshub.com/raya-meaning/"
}, {
  letter: "R",
  name: "Rayna",
  meaning: "Queen",
  url: "https://shulisnameshub.com/rayna-meaning/"
}, {
  letter: "R",
  name: "Rayne",
  meaning: "Queen",
  url: "https://shulisnameshub.com/rayne-meaning/"
}, {
  letter: "R",
  name: "Reagan",
  meaning: "Little ruler",
  url: "https://shulisnameshub.com/reagan-meaning/"
}, {
  letter: "R",
  name: "Rebecca",
  meaning: "To bind",
  url: "https://shulisnameshub.com/rebecca-meaning/"
}, {
  letter: "R",
  name: "Rebekah",
  meaning: "To bind",
  url: "https://shulisnameshub.com/rebekah-meaning/"
}, {
  letter: "R",
  name: "Reese",
  meaning: "Ardor",
  url: "https://shulisnameshub.com/reese-meaning/"
}, {
  letter: "R",
  name: "Regina",
  meaning: "Queen",
  url: "https://shulisnameshub.com/regina-meaning/"
}, {
  letter: "R",
  name: "Reign",
  meaning: "Rule",
  url: "https://shulisnameshub.com/reign-meaning/"
}, {
  letter: "R",
  name: "Remi",
  meaning: "Oarsman",
  url: "https://shulisnameshub.com/remi-meaning/"
}, {
  letter: "R",
  name: "Remington",
  meaning: "Raven's town",
  url: "https://shulisnameshub.com/remington-meaning/"
}, {
  letter: "R",
  name: "Remy",
  meaning: "Oarsman",
  url: "https://shulisnameshub.com/remy-meaning/"
}, {
  letter: "R",
  name: "Rena",
  meaning: "Joyous song",
  url: "https://shulisnameshub.com/rena-meaning/"
}, {
  letter: "R",
  name: "Renata",
  meaning: "Reborn",
  url: "https://shulisnameshub.com/renata-meaning/"
}, {
  letter: "R",
  name: "Rene",
  meaning: "Reborn",
  url: "https://shulisnameshub.com/rene-meaning/"
}, {
  letter: "R",
  name: "Renee",
  meaning: "Reborn",
  url: "https://shulisnameshub.com/renee-meaning/"
}, {
  letter: "R",
  name: "Reshma",
  meaning: "Silken",
  url: "https://shulisnameshub.com/reshma-meaning/"
}, {
  letter: "R",
  name: "Rhea",
  meaning: "Flowing",
  url: "https://shulisnameshub.com/rhea-meaning/"
}, {
  letter: "R",
  name: "Rhiannon",
  meaning: "Great queen",
  url: "https://shulisnameshub.com/rhiannon-meaning/"
}, {
  letter: "R",
  name: "Riley",
  meaning: "Courageous",
  url: "https://shulisnameshub.com/riley-meaning/"
}, {
  letter: "R",
  name: "Rita",
  meaning: "Pearl",
  url: "https://shulisnameshub.com/rita-meaning/"
}, {
  letter: "R",
  name: "River",
  meaning: "Stream of water",
  url: "https://shulisnameshub.com/river-meaning/"
}, {
  letter: "R",
  name: "Rivka",
  meaning: "To bind",
  url: "https://shulisnameshub.com/rivka-meaning/"
}, {
  letter: "R",
  name: "Robyn",
  meaning: "Bright fame",
  url: "https://shulisnameshub.com/robyn-meaning/"
}, {
  letter: "R",
  name: "Rory",
  meaning: "Red king",
  url: "https://shulisnameshub.com/rory-meaning/"
}, {
  letter: "R",
  name: "Rosa",
  meaning: "Rose",
  url: "https://shulisnameshub.com/rosa-meaning/"
}, {
  letter: "R",
  name: "Rosalie",
  meaning: "Rose",
  url: "https://shulisnameshub.com/rosalie-meaning/"
}, {
  letter: "R",
  name: "Rosalind",
  meaning: "Beautiful rose",
  url: "https://shulisnameshub.com/rosalind-meaning/"
}, {
  letter: "R",
  name: "Rosalyn",
  meaning: "Beautiful rose",
  url: "https://shulisnameshub.com/rosalyn-meaning/"
}, {
  letter: "R",
  name: "Rose",
  meaning: "Flower",
  url: "https://shulisnameshub.com/rose-meaning/"
}, {
  letter: "R",
  name: "Roselyn",
  meaning: "Rose",
  url: "https://shulisnameshub.com/roselyn-meaning/"
}, {
  letter: "R",
  name: "Rosemary",
  meaning: "Dew of the sea",
  url: "https://shulisnameshub.com/rosemary-meaning/"
}, {
  letter: "R",
  name: "Rosie",
  meaning: "Rose",
  url: "https://shulisnameshub.com/rosie-meaning/"
}, {
  letter: "R",
  name: "Rowan",
  meaning: "Little red-head",
  url: "https://shulisnameshub.com/rowan-meaning/"
}, {
  letter: "R",
  name: "Royal",
  meaning: "Regal",
  url: "https://shulisnameshub.com/royal-meaning/"
}, {
  letter: "R",
  name: "Ruby",
  meaning: "Red gemstone",
  url: "https://shulisnameshub.com/ruby-meaning/"
}, {
  letter: "R",
  name: "Ruth",
  meaning: "Compassionate friend",
  url: "https://shulisnameshub.com/ruth-meaning/"
}, {
  letter: "R",
  name: "Ryan",
  meaning: "Little king",
  url: "https://shulisnameshub.com/ryan-meaning/"
}, {
  letter: "R",
  name: "Ryann",
  meaning: "Little king",
  url: "https://shulisnameshub.com/ryann-meaning/"
}, {
  letter: "R",
  name: "Rylan",
  meaning: "Island meadow",
  url: "https://shulisnameshub.com/rylan-meaning/"
}, {
  letter: "R",
  name: "Rylee",
  meaning: "Courageous",
  url: "https://shulisnameshub.com/rylee-meaning/"
}, {
  letter: "R",
  name: "Ryleigh",
  meaning: "Courageous",
  url: "https://shulisnameshub.com/ryleigh-meaning/"
}, {
  letter: "R",
  name: "Rylie",
  meaning: "Courageous",
  url: "https://shulisnameshub.com/rylie-meaning/"
}, {
  letter: "S",
  name: "Saanvi",
  meaning: "Goddess Lakshmi",
  url: "https://shulisnameshub.com/saanvi-meaning/"
}, {
  letter: "S",
  name: "Sabrina",
  meaning: "From the River Severn",
  url: "https://shulisnameshub.com/sabrina-meaning/"
}, {
  letter: "S",
  name: "Sade",
  meaning: "Honor confers a crown",
  url: "https://shulisnameshub.com/sade-meaning/"
}, {
  letter: "S",
  name: "Sadie",
  meaning: "Princess",
  url: "https://shulisnameshub.com/sadie-meaning/"
}, {
  letter: "S",
  name: "Sage",
  meaning: "Wise",
  url: "https://shulisnameshub.com/sage-meaning/"
}, {
  letter: "S",
  name: "Saige",
  meaning: "Wise",
  url: "https://shulisnameshub.com/saige-meaning/"
}, {
  letter: "S",
  name: "Salem",
  meaning: "Peace",
  url: "https://shulisnameshub.com/salem-meaning/"
}, {
  letter: "S",
  name: "Salma",
  meaning: "Peace",
  url: "https://shulisnameshub.com/salma-meaning/"
}, {
  letter: "S",
  name: "Samantha",
  meaning: "Told by God",
  url: "https://shulisnameshub.com/samantha-meaning/"
}, {
  letter: "S",
  name: "Samara",
  meaning: "Guardian",
  url: "https://shulisnameshub.com/samara-meaning/"
}, {
  letter: "S",
  name: "Samira",
  meaning: "Companion in evening talk",
  url: "https://shulisnameshub.com/samira-meaning/"
}, {
  letter: "S",
  name: "Sanaa",
  meaning: "Radiance",
  url: "https://shulisnameshub.com/sanaa-meaning/"
}, {
  letter: "S",
  name: "Sandra",
  meaning: "Defender of mankind",
  url: "https://shulisnameshub.com/sandra-meaning/"
}, {
  letter: "S",
  name: "Saniyah",
  meaning: "Resplendent",
  url: "https://shulisnameshub.com/saniyah-meaning/"
}, {
  letter: "S",
  name: "Saoirse",
  meaning: "Freedom",
  url: "https://shulisnameshub.com/saoirse-meaning/"
}, {
  letter: "S",
  name: "Sara",
  meaning: "Princess",
  url: "https://shulisnameshub.com/sara-meaning/"
}, {
  letter: "S",
  name: "Sarah",
  meaning: "Princess",
  url: "https://shulisnameshub.com/sarah-meaning/"
}, {
  letter: "S",
  name: "Sarai",
  meaning: "Princess",
  url: "https://shulisnameshub.com/sarai-meaning/"
}, {
  letter: "S",
  name: "Sariah",
  meaning: "Princess of the Lord",
  url: "https://shulisnameshub.com/sariah-meaning/"
}, {
  letter: "S",
  name: "Sasha",
  meaning: "Defender of mankind",
  url: "https://shulisnameshub.com/sasha-meaning/"
}, {
  letter: "S",
  name: "Savanna",
  meaning: "Tropical grassland",
  url: "https://shulisnameshub.com/savanna-meaning/"
}, {
  letter: "S",
  name: "Savannah",
  meaning: "Tropical grassland",
  url: "https://shulisnameshub.com/savannah-meaning/"
}, {
  letter: "S",
  name: "Sawyer",
  meaning: "Woodcutter",
  url: "https://shulisnameshub.com/sawyer-meaning/"
}, {
  letter: "S",
  name: "Saylor",
  meaning: "Sailor",
  url: "https://shulisnameshub.com/saylor-meaning/"
}, {
  letter: "S",
  name: "Scarlet",
  meaning: "Red",
  url: "https://shulisnameshub.com/scarlet-meaning/"
}, {
  letter: "S",
  name: "Scarlett",
  meaning: "Red",
  url: "https://shulisnameshub.com/scarlett-meaning/"
}, {
  letter: "S",
  name: "Scarlette",
  meaning: "Red",
  url: "https://shulisnameshub.com/scarlette-meaning/"
}, {
  letter: "S",
  name: "Selah",
  meaning: "Praise",
  url: "https://shulisnameshub.com/selah-meaning/"
}, {
  letter: "S",
  name: "Selena",
  meaning: "Moon",
  url: "https://shulisnameshub.com/selena-meaning/"
}, {
  letter: "S",
  name: "Selene",
  meaning: "Moon",
  url: "https://shulisnameshub.com/selene-meaning/"
}, {
  letter: "S",
  name: "Seraphina",
  meaning: "Fiery ones",
  url: "https://shulisnameshub.com/seraphina-meaning/"
}, {
  letter: "S",
  name: "Serena",
  meaning: "Serene",
  url: "https://shulisnameshub.com/serena-meaning/"
}, {
  letter: "S",
  name: "Serenity",
  meaning: "Peaceful",
  url: "https://shulisnameshub.com/serenity-meaning/"
}, {
  letter: "S",
  name: "Shay",
  meaning: "Stately",
  url: "https://shulisnameshub.com/shay-meaning/"
}, {
  letter: "S",
  name: "Shelby",
  meaning: "Willow farm",
  url: "https://shulisnameshub.com/shelby-meaning/"
}, {
  letter: "S",
  name: "Shiloh",
  meaning: "Peace",
  url: "https://shulisnameshub.com/shiloh-meaning/"
}, {
  letter: "S",
  name: "Sia",
  meaning: "Victory",
  url: "https://shulisnameshub.com/sia-meaning/"
}, {
  letter: "S",
  name: "Siana",
  meaning: "God is gracious",
  url: "https://shulisnameshub.com/siana-meaning/"
}, {
  letter: "S",
  name: "Sienna",
  meaning: "Orange-red",
  url: "https://shulisnameshub.com/sienna-meaning/"
}, {
  letter: "S",
  name: "Sierra",
  meaning: "Mountain range",
  url: "https://shulisnameshub.com/sierra-meaning/"
}, {
  letter: "S",
  name: "Simone",
  meaning: "Heard",
  url: "https://shulisnameshub.com/simone-meaning/"
}, {
  letter: "S",
  name: "Sky",
  meaning: "Atmosphere",
  url: "https://shulisnameshub.com/sky-meaning/"
}, {
  letter: "S",
  name: "Skye",
  meaning: "Atmosphere",
  url: "https://shulisnameshub.com/skye-meaning/"
}, {
  letter: "S",
  name: "Skyla",
  meaning: "Scholar",
  url: "https://shulisnameshub.com/skyla-meaning/"
}, {
  letter: "S",
  name: "Skylar",
  meaning: "Scholar",
  url: "https://shulisnameshub.com/skylar-meaning/"
}, {
  letter: "S",
  name: "Skyler",
  meaning: "Scholar",
  url: "https://shulisnameshub.com/skyler-meaning/"
}, {
  letter: "S",
  name: "Sloane",
  meaning: "Raider",
  url: "https://shulisnameshub.com/sloane-meaning/"
}, {
  letter: "S",
  name: "Sofia",
  meaning: "Wisdom",
  url: "https://shulisnameshub.com/sofia-meaning/"
}, {
  letter: "S",
  name: "Sophia",
  meaning: "Wisdom",
  url: "https://shulisnameshub.com/sophia-meaning/"
}, {
  letter: "S",
  name: "Sophie",
  meaning: "Wisdom",
  url: "https://shulisnameshub.com/sophie-meaning/"
}, {
  letter: "S",
  name: "Sora",
  meaning: "Sky",
  url: "https://shulisnameshub.com/sora-meaning/"
}, {
  letter: "S",
  name: "Stacy",
  meaning: "Resurrection",
  url: "https://shulisnameshub.com/stacy-meaning/"
}, {
  letter: "S",
  name: "Stella",
  meaning: "Star",
  url: "https://shulisnameshub.com/stella-meaning/"
}, {
  letter: "S",
  name: "Stephanie",
  meaning: "Crown",
  url: "https://shulisnameshub.com/stephanie-meaning/"
}, {
  letter: "S",
  name: "Stevie",
  meaning: "Crown",
  url: "https://shulisnameshub.com/stevie-meaning/"
}, {
  letter: "S",
  name: "Storm",
  meaning: "Tempest",
  url: "https://shulisnameshub.com/storm-meaning/"
}, {
  letter: "S",
  name: "Summer",
  meaning: "Season",
  url: "https://shulisnameshub.com/summer-meaning/"
}, {
  letter: "S",
  name: "Sunny",
  meaning: "Cheerful",
  url: "https://shulisnameshub.com/sunny-meaning/"
}, {
  letter: "S",
  name: "Sutton",
  meaning: "Southern settlement",
  url: "https://shulisnameshub.com/sutton-meaning/"
}, {
  letter: "S",
  name: "Sydney",
  meaning: "Wide island",
  url: "https://shulisnameshub.com/sydney-meaning/"
}, {
  letter: "S",
  name: "Sylvia",
  meaning: "From the forest",
  url: "https://shulisnameshub.com/sylvia-meaning/"
}, {
  letter: "S",
  name: "Sylvie",
  meaning: "From the forest",
  url: "https://shulisnameshub.com/sylvie-meaning/"
}, {
  letter: "T",
  name: "Tabitha",
  meaning: "Gazelle",
  url: "https://shulisnameshub.com/tabitha-meaning/"
}, {
  letter: "T",
  name: "Talia",
  meaning: "Dew from God",
  url: "https://shulisnameshub.com/talia-meaning/"
}, {
  letter: "T",
  name: "Tallulah",
  meaning: "Leaping water",
  url: "https://shulisnameshub.com/tallulah-meaning/"
}, {
  letter: "T",
  name: "Tamara",
  meaning: "Date palm",
  url: "https://shulisnameshub.com/tamara-meaning/"
}, {
  letter: "T",
  name: "Tania",
  meaning: "Fairy queen",
  url: "https://shulisnameshub.com/tania-meaning/"
}, {
  letter: "T",
  name: "Tanya",
  meaning: "Fairy queen",
  url: "https://shulisnameshub.com/tanya-meaning/"
}, {
  letter: "T",
  name: "Tara",
  meaning: "Star",
  url: "https://shulisnameshub.com/tara-meaning/"
}, {
  letter: "T",
  name: "Tatum",
  meaning: "Tate's homestead",
  url: "https://shulisnameshub.com/tatum-meaning/"
}, {
  letter: "T",
  name: "Taylor",
  meaning: "Tailor",
  url: "https://shulisnameshub.com/taylor-meaning/"
}, {
  letter: "T",
  name: "Teagan",
  meaning: "Little poet",
  url: "https://shulisnameshub.com/teagan-meaning/"
}, {
  letter: "T",
  name: "Teresa",
  meaning: "To harvest",
  url: "https://shulisnameshub.com/teresa-meaning/"
}, {
  letter: "T",
  name: "Tessa",
  meaning: "To reap",
  url: "https://shulisnameshub.com/tessa-meaning/"
}, {
  letter: "T",
  name: "Thalia",
  meaning: "To blossom",
  url: "https://shulisnameshub.com/thalia-meaning/"
}, {
  letter: "T",
  name: "Thea",
  meaning: "Goddess",
  url: "https://shulisnameshub.com/thea-meaning/"
}, {
  letter: "T",
  name: "Theodora",
  meaning: "Gift of God",
  url: "https://shulisnameshub.com/theodora-meaning/"
}, {
  letter: "T",
  name: "Tiana",
  meaning: "Princess",
  url: "https://shulisnameshub.com/tiana-meaning/"
}, {
  letter: "T",
  name: "Tiffany",
  meaning: "Appearance of God",
  url: "https://shulisnameshub.com/tiffany-meaning/"
}, {
  letter: "T",
  name: "Tinsley",
  meaning: "Tynni's meadow",
  url: "https://shulisnameshub.com/tinsley-meaning/"
}, {
  letter: "T",
  name: "Tori",
  meaning: "Victory",
  url: "https://shulisnameshub.com/tori-meaning/"
}, {
  letter: "T",
  name: "Tracy",
  meaning: "From Thracia",
  url: "https://shulisnameshub.com/tracy-meaning/"
}, {
  letter: "T",
  name: "Treasure",
  meaning: "Valuable",
  url: "https://shulisnameshub.com/treasure-meaning/"
}, {
  letter: "T",
  name: "Trinity",
  meaning: "Threefold",
  url: "https://shulisnameshub.com/trinity-meaning/"
}, {
  letter: "T",
  name: "Trixie",
  meaning: "Bringer of joy",
  url: "https://shulisnameshub.com/trixie-meaning/"
}, {
  letter: "U",
  name: "Uma",
  meaning: "Nation",
  url: "https://shulisnameshub.com/uma-meaning/"
}, {
  letter: "U",
  name: "Una",
  meaning: "One",
  url: "https://shulisnameshub.com/una-meaning/"
}, {
  letter: "U",
  name: "Unique",
  meaning: "Only one",
  url: "https://shulisnameshub.com/unique-meaning/"
}, {
  letter: "U",
  name: "Unity",
  meaning: "Oneness",
  url: "https://shulisnameshub.com/unity-meaning/"
}, {
  letter: "U",
  name: "Ursula",
  meaning: "Little bear",
  url: "https://shulisnameshub.com/ursula-meaning/"
}, {
  letter: "V",
  name: "Valencia",
  meaning: "Brave",
  url: "https://shulisnameshub.com/valencia-meaning/"
}, {
  letter: "V",
  name: "Valentina",
  meaning: "Strong, healthy",
  url: "https://shulisnameshub.com/valentina-meaning/"
}, {
  letter: "V",
  name: "Valeria",
  meaning: "Strong",
  url: "https://shulisnameshub.com/valeria-meaning/"
}, {
  letter: "V",
  name: "Valerie",
  meaning: "Strong, brave",
  url: "https://shulisnameshub.com/valerie-meaning/"
}, {
  letter: "V",
  name: "Vanesa",
  meaning: "Butterfly",
  url: "https://shulisnameshub.com/vanesa-meaning/"
}, {
  letter: "V",
  name: "Vanessa",
  meaning: "Butterfly",
  url: "https://shulisnameshub.com/vanessa-meaning/"
}, {
  letter: "V",
  name: "Veda",
  meaning: "Knowledge",
  url: "https://shulisnameshub.com/veda-meaning/"
}, {
  letter: "V",
  name: "Vera",
  meaning: "Faith",
  url: "https://shulisnameshub.com/vera-meaning/"
}, {
  letter: "V",
  name: "Veronica",
  meaning: "true image",
  url: "https://shulisnameshub.com/veronica-meaning/"
}, {
  letter: "V",
  name: "Victoria",
  meaning: "Victory",
  url: "https://shulisnameshub.com/victoria-meaning/"
}, {
  letter: "V",
  name: "Vienna",
  meaning: "From wine country",
  url: "https://shulisnameshub.com/vienna-meaning/"
}, {
  letter: "V",
  name: "Viola",
  meaning: "Violet",
  url: "https://shulisnameshub.com/viola-meaning/"
}, {
  letter: "V",
  name: "Violet",
  meaning: "Purple flower",
  url: "https://shulisnameshub.com/violet-meaning/"
}, {
  letter: "V",
  name: "Violeta",
  meaning: "Violet",
  url: "https://shulisnameshub.com/violeta-meaning/"
}, {
  letter: "V",
  name: "Violette",
  meaning: "Violet",
  url: "https://shulisnameshub.com/violette-meaning/"
}, {
  letter: "V",
  name: "Virginia",
  meaning: "Maiden",
  url: "https://shulisnameshub.com/virginia-meaning/"
}, {
  letter: "V",
  name: "Vivian",
  meaning: "Alive",
  url: "https://shulisnameshub.com/vivian-meaning/"
}, {
  letter: "V",
  name: "Viviana",
  meaning: "Alive",
  url: "https://shulisnameshub.com/viviana-meaning/"
}, {
  letter: "V",
  name: "Vivienne",
  meaning: "Alive",
  url: "https://shulisnameshub.com/vivienne-meaning/"
}, {
  letter: "W",
  name: "Walker",
  meaning: "Cloth walker",
  url: "https://shulisnameshub.com/walker-meaning/"
}, {
  letter: "W",
  name: "Wallis",
  meaning: "From Wales",
  url: "https://shulisnameshub.com/wallis-meaning/"
}, {
  letter: "W",
  name: "Wanda",
  meaning: "Shepherdess",
  url: "https://shulisnameshub.com/wanda-meaning/"
}, {
  letter: "W",
  name: "Waverly",
  meaning: "Meadow of quaking aspens",
  url: "https://shulisnameshub.com/waverly-meaning/"
}, {
  letter: "W",
  name: "Wendy",
  meaning: "Friend",
  url: "https://shulisnameshub.com/wendy-meaning/"
}, {
  letter: "W",
  name: "Whitley",
  meaning: "White meadow",
  url: "https://shulisnameshub.com/whitley-meaning/"
}, {
  letter: "W",
  name: "Whitney",
  meaning: "White island",
  url: "https://shulisnameshub.com/whitney-meaning/"
}, {
  letter: "W",
  name: "Willa",
  meaning: "Resolute protection",
  url: "https://shulisnameshub.com/willa-meaning/"
}, {
  letter: "W",
  name: "Willow",
  meaning: "Willow tree",
  url: "https://shulisnameshub.com/willow-meaning/"
}, {
  letter: "W",
  name: "Winifred",
  meaning: "Blessed peacemaker",
  url: "https://shulisnameshub.com/winifred-meaning/"
}, {
  letter: "W",
  name: "Winona",
  meaning: "Firstborn daughter",
  url: "https://shulisnameshub.com/winona-meaning/"
}, {
  letter: "W",
  name: "Winter",
  meaning: "The season",
  url: "https://shulisnameshub.com/winter-meaning/"
}, {
  letter: "W",
  name: "Wren",
  meaning: "Small bird",
  url: "https://shulisnameshub.com/wren-meaning/"
}, {
  letter: "W",
  name: "Wrenley",
  meaning: "Small bird",
  url: "https://shulisnameshub.com/wrenley-meaning/"
}, {
  letter: "W",
  name: "Wyatt",
  meaning: "Brave in war",
  url: "https://shulisnameshub.com/wyatt-meaning/"
}, {
  letter: "W",
  name: "Wynter",
  meaning: "Winter",
  url: "https://shulisnameshub.com/wynter-meaning/"
}, {
  letter: "X",
  name: "Xandra",
  meaning: "Defender of mankind",
  url: "https://shulisnameshub.com/xandra-meaning/"
}, {
  letter: "X",
  name: "Xanthe",
  meaning: "Golden, yellow",
  url: "https://shulisnameshub.com/xanthe-meaning/"
}, {
  letter: "X",
  name: "Xara",
  meaning: "Princess",
  url: "https://shulisnameshub.com/xara-meaning/"
}, {
  letter: "X",
  name: "Xena",
  meaning: "Guest",
  url: "https://shulisnameshub.com/xena-meaning/"
}, {
  letter: "X",
  name: "Xenia",
  meaning: "Hospitality",
  url: "https://shulisnameshub.com/xenia-meaning/"
}, {
  letter: "X",
  name: "Ximena",
  meaning: "He listener",
  url: "https://shulisnameshub.com/ximena-meaning/"
}, {
  letter: "X",
  name: "Xiomara",
  meaning: "Famous in battle",
  url: "https://shulisnameshub.com/xiomara-meaning/"
}, {
  letter: "Y",
  name: "Yara",
  meaning: "Small butterfly",
  url: "https://shulisnameshub.com/yara-meaning/"
}, {
  letter: "Y",
  name: "Yareli",
  meaning: "Water lady",
  url: "https://shulisnameshub.com/yareli-meaning/"
}, {
  letter: "Y",
  name: "Yaretzi",
  meaning: "You will always be loved",
  url: "https://shulisnameshub.com/yaretzi-meaning/"
}, {
  letter: "Y",
  name: "Yasmine",
  meaning: "Jasmine flower",
  url: "https://shulisnameshub.com/yasmine-meaning/"
}, {
  letter: "Y",
  name: "Yelena",
  meaning: "Bright, shining light",
  url: "https://shulisnameshub.com/yelena-meaning/"
}, {
  letter: "Y",
  name: "Yesenia",
  meaning: "Palm tree",
  url: "https://shulisnameshub.com/yesenia-meaning/"
}, {
  letter: "Y",
  name: "Yolanda",
  meaning: "Violet flower",
  url: "https://shulisnameshub.com/yolanda-meaning/"
}, {
  letter: "Y",
  name: "Yvonne",
  meaning: "Yew wood",
  url: "https://shulisnameshub.com/yvonne-meaning/"
}, {
  letter: "Z",
  name: "Zahra",
  meaning: "Beautiful, bright",
  url: "https://shulisnameshub.com/zahra-meaning/"
}, {
  letter: "Z",
  name: "Zainab",
  meaning: "Fragrant flower",
  url: "https://shulisnameshub.com/zainab-meaning/"
}, {
  letter: "Z",
  name: "Zaniyah",
  meaning: "Forever",
  url: "https://shulisnameshub.com/zaniyah-meaning/"
}, {
  letter: "Z",
  name: "Zara",
  meaning: "Princess",
  url: "https://shulisnameshub.com/zara-meaning/"
}, {
  letter: "Z",
  name: "Zaria",
  meaning: "Princess",
  url: "https://shulisnameshub.com/zaria-meaning/"
}, {
  letter: "Z",
  name: "Zariah",
  meaning: "Princess",
  url: "https://shulisnameshub.com/zariah-meaning/"
}, {
  letter: "Z",
  name: "Zaya",
  meaning: "Hope",
  url: "https://shulisnameshub.com/zaya-meaning/"
}, {
  letter: "Z",
  name: "Zelda",
  meaning: "Gray fighting maid",
  url: "https://shulisnameshub.com/zelda-meaning/"
}, {
  letter: "Z",
  name: "Zendaya",
  meaning: "To give thanks",
  url: "https://shulisnameshub.com/zendaya-meaning/"
}, {
  letter: "Z",
  name: "Zia",
  meaning: "Light",
  url: "https://shulisnameshub.com/zia-meaning/"
}, {
  letter: "Z",
  name: "Zina",
  meaning: "Guest",
  url: "https://shulisnameshub.com/zina-meaning/"
}, {
  letter: "Z",
  name: "Zion",
  meaning: "Highest point",
  url: "https://shulisnameshub.com/zion-meaning/"
}, {
  letter: "Z",
  name: "Zoe",
  meaning: "Life",
  url: "https://shulisnameshub.com/zoe-meaning/"
}, {
  letter: "Z",
  name: "Zoey",
  meaning: "Life",
  url: "https://shulisnameshub.com/zoey-meaning/"
}, {
  letter: "Z",
  name: "Zora",
  meaning: "Dawn",
  url: "https://shulisnameshub.com/zora-meaning/"
}, {
  letter: "Z",
  name: "Zoya",
  meaning: "Alive",
  url: "https://shulisnameshub.com/zoya-meaning/"
}, {
  letter: "Z",
  name: "Zuri",
  meaning: "Beautiful",
  url: "https://shulisnameshub.com/zuri-meaning/"
}];
const trendingNames = [{
  id: 1,
  name: "Olivia",
  trend: "up"
}, {
  id: 2,
  name: "Emma",
  trend: "stable"
}, {
  id: 3,
  name: "Charlotte",
  trend: "up"
}, {
  id: 4,
  name: "Amelia",
  trend: "up"
}, {
  id: 5,
  name: "Ava",
  trend: "down"
}, {
  id: 6,
  name: "Sophia",
  trend: "stable"
}, {
  id: 7,
  name: "Isabella",
  trend: "down"
}];
export default function GirlNameDirectory() {
  return <section id="girl-name-directory" className="bg-background py-16 px-4 md:px-8 font-sans">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-4 gap-8">
        
        <div className="lg:col-span-3 space-y-10">
          
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold text-chart-1 tracking-tight">
              Girl Names Directory
            </h1>
            <p className="text-lg text-foreground max-w-2xl">
              A curated alphabetical list of beautiful and trending girl names. Browse through our comprehensive collection to find the perfect name.
            </p>
          </div>

          <div className="space-y-12">
            {alphabet.map((letter, i) => {
            const filteredNames = namesData.filter(n => n.letter === letter);
            if (filteredNames.length === 0) return null;
            return <div key={letter} data-index={i} id={`letter-${letter}`} className="scroll-mt-32">
                  <h2 className="text-3xl font-bold text-chart-1 border-b-2 border-accent pb-3 mb-6">
                    {letter}
                  </h2>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-y-4 gap-x-6">
                    {filteredNames.map((item, j) => <div key={item.name} data-index={j} className="flex flex-col">
                        <Link to={item.url || "#"} newTab={!!item.url} className="text-foreground hover:text-secondary transition-colors text-base font-medium w-full py-1">
                          {item.name}
                        </Link>
                        {item.meaning && <span className="text-xs text-muted-foreground italic">
                            {item.meaning}
                          </span>}
                      </div>)}
                  </div>
                  {letter === "A" && <div className="mt-8">
                      <Link to="/NameStartingWithTheLetterAPage">
                        <Button className="bg-secondary text-secondary-foreground hover:bg-accent hover:text-accent-foreground rounded-lg px-8 py-6 text-lg font-bold transition-all">
                          Name Starting With The letter A
                        </Button>
                      </Link>
                    </div>}
                </div>;
          })}
          </div>
          
          <div className="pt-8 flex justify-center border-t border-border">
             <Button variant="outline" className="text-chart-1 border-chart-1 hover:bg-chart-1 hover:text-primary-foreground rounded-lg px-8 py-6 text-lg">
                Load More Names
             </Button>
          </div>

        </div>

        <div className="lg:col-span-1">
          <div className="sticky top-24 space-y-8">
            <Card className="bg-card border-none shadow-sm rounded-lg">
              <CardHeader className="pb-4 border-b border-card-foreground/10">
                <CardTitle className="text-xl font-bold text-chart-1">
                  Trending Girls Names
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-6">
                <ul className="space-y-4">
                  {trendingNames.map((item, i) => <li key={item.id} data-index={i} className="flex items-center justify-between group">
                      <Link to="#" className="text-card-foreground group-hover:text-secondary font-medium transition-colors text-base">
                        {i + 1}. {item.name}
                      </Link>
                      <span className="text-card-foreground/60 flex items-center justify-center w-6 h-6">
                        {item.trend === "up" && <TrendingUp className="w-4 h-4 text-chart-2" />}
                        {item.trend === "down" && <TrendingDown className="w-4 h-4 text-destructive" />}
                        {item.trend === "stable" && <Minus className="w-4 h-4" />}
                      </span>
                    </li>)}
                </ul>
                <Button variant="default" className="w-full mt-8 bg-secondary text-secondary-foreground hover:bg-accent hover:text-accent-foreground rounded-lg py-6 text-base font-semibold transition-colors">
                  View Top 100
                </Button>
              </CardContent>
            </Card>
            
            <Card className="bg-muted border-none shadow-sm rounded-lg">
              <CardContent className="p-6 text-center space-y-4">
                 <h3 className="text-lg font-bold text-chart-1">Need Inspiration?</h3>
                 <p className="text-sm text-foreground">Try our random name generator to find unique ideas.</p>
                 <Button variant="outline" className="w-full rounded-lg border-chart-1 text-chart-1 hover:bg-chart-1 hover:text-primary-foreground">
                    Generate Name
                 </Button>
              </CardContent>
            </Card>

            <Card className="bg-card border-none shadow-sm rounded-lg sticky top-32">
              <CardHeader className="pb-4 border-b border-card-foreground/10">
                <CardTitle className="text-xl font-bold text-chart-1">
                  Quick Jump
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-6">
                <div className="grid grid-cols-4 gap-2">
                  {alphabet.map((letter, i) => <Link key={letter} data-index={i} to={`#letter-${letter}`} className="w-10 h-10 flex items-center justify-center bg-background text-foreground hover:bg-accent hover:text-accent-foreground transition-colors text-sm font-bold border border-border rounded-lg">
                      {letter}
                    </Link>)}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

      </div>
    </section>;
}